
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire6be7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire6be7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("bCl3L", function(module, exports) {

$parcel$export(module.exports, "trackCheckupStart", () => $87539454b7a59f3a$export$1ccf918b6f8bf2a3);
$parcel$export(module.exports, "trackCheckupStep", () => $87539454b7a59f3a$export$40f59195ab1b0bf9);
$parcel$export(module.exports, "trackCheckupResume", () => $87539454b7a59f3a$export$b850db2c86999a8a);
$parcel$export(module.exports, "trackCheckupComplete", () => $87539454b7a59f3a$export$c2b3c1fff8750f6a);
$parcel$export(module.exports, "trackCheckupAction", () => $87539454b7a59f3a$export$64a98dd67fee4614);
// Eventi del check-up finanziario.
// Convenzione del sito: si pusha nel dataLayer, GTM inoltra a GA4 (vedi trackedLinks.js).
// Nessun dato finanziario o personale negli eventi: solo contatori, punteggio e livello.
// L'ordine deve seguire SUBSTEP_CONFIG in financialPlannerWizard.js: 5 raccoglie i debiti
// (debt_status, mutuo, prestito, revolving), 6 le spese previste e 7 il lungo termine.
const $87539454b7a59f3a$var$STEP_KEYS = {
    1: 'situazione',
    2: 'entrate_spese',
    3: 'liquidita',
    4: 'fondo_emergenza',
    5: 'debiti',
    6: 'obiettivi',
    7: 'investimenti',
    8: 'riepilogo'
};
const $87539454b7a59f3a$var$COMPLETE_TRACKED_KEY = 'checkup_complete_tracked_v1';
const $87539454b7a59f3a$var$COMPLETE_TRACKED_MAX = 20;
let $87539454b7a59f3a$var$startSent = false;
const $87539454b7a59f3a$var$sentSteps = new Set();
function $87539454b7a59f3a$var$push(event, params = {}) {
    if (typeof window === 'undefined') return;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: event,
        ...params
    });
}
/** Impronta corta della compilazione: distingue un check-up dall'altro senza ricopiare i dati in chiaro. */ function $87539454b7a59f3a$var$fingerprint(value) {
    let hash = 0;
    for(let i = 0; i < value.length; i += 1)hash = Math.imul(hash, 31) + value.charCodeAt(i) | 0;
    return (hash >>> 0).toString(36);
}
/** True se questa compilazione era gia stata contata, anche in una visita precedente. */ function $87539454b7a59f3a$var$alreadyCounted(key) {
    try {
        const seen = JSON.parse(localStorage.getItem($87539454b7a59f3a$var$COMPLETE_TRACKED_KEY) || '[]');
        if (seen.includes(key)) return true;
        localStorage.setItem($87539454b7a59f3a$var$COMPLETE_TRACKED_KEY, JSON.stringify([
            ...seen,
            key
        ].slice(-$87539454b7a59f3a$var$COMPLETE_TRACKED_MAX)));
    } catch (error) {}
    return false;
}
function $87539454b7a59f3a$export$1ccf918b6f8bf2a3() {
    if ($87539454b7a59f3a$var$startSent) return;
    $87539454b7a59f3a$var$startSent = true;
    $87539454b7a59f3a$var$push('checkup_start');
}
function $87539454b7a59f3a$export$40f59195ab1b0bf9(step, substepKey, progressPercent) {
    const id = `${step}:${substepKey}`;
    if ($87539454b7a59f3a$var$sentSteps.has(id)) return; // una sola volta per schermata: conta il raggiungimento, non i rimbalzi avanti/indietro
    $87539454b7a59f3a$var$sentSteps.add(id);
    $87539454b7a59f3a$var$push('checkup_step', {
        checkup_step: step,
        checkup_step_name: $87539454b7a59f3a$var$STEP_KEYS[step] || String(step),
        checkup_substep: `${step}_${substepKey}`,
        checkup_progress: Math.round(progressPercent)
    });
}
function $87539454b7a59f3a$export$b850db2c86999a8a(step) {
    $87539454b7a59f3a$var$push('checkup_resume', {
        checkup_step: step
    });
}
function $87539454b7a59f3a$export$c2b3c1fff8750f6a(score, level) {
    if (typeof window === 'undefined') return;
    if ($87539454b7a59f3a$var$alreadyCounted($87539454b7a59f3a$var$fingerprint(`${score}:${level}:${window.location.search}`))) return;
    $87539454b7a59f3a$var$push('checkup_complete', {
        checkup_score: score,
        checkup_level: level
    });
}
function $87539454b7a59f3a$export$64a98dd67fee4614(action) {
    $87539454b7a59f3a$var$push('checkup_action', {
        checkup_action: action
    });
}

});

parcelRegister("ctPgg", function(module, exports) {

$parcel$export(module.exports, "downloadBackup", () => $915ff4e2eda66ed0$export$a311c3f3cfaee39);
$parcel$export(module.exports, "readBackupFile", () => $915ff4e2eda66ed0$export$588053414608fe9a);
$parcel$export(module.exports, "formatBackupDate", () => $915ff4e2eda66ed0$export$5f15fc6b1108a9e7);
// Export/import del check-up come file JSON locale.
// Nessuna chiamata di rete: i dati restano sul dispositivo dell'utente.
const $915ff4e2eda66ed0$var$APP_ID = 'stipendee-check-up';
const $915ff4e2eda66ed0$var$SCHEMA = 1;
function $915ff4e2eda66ed0$var$formatDateForFilename(date) {
    const pad = (n)=>String(n).padStart(2, '0');
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
}
function $915ff4e2eda66ed0$export$a311c3f3cfaee39(data, score) {
    const now = new Date();
    const backup = {
        app: $915ff4e2eda66ed0$var$APP_ID,
        schema: $915ff4e2eda66ed0$var$SCHEMA,
        savedAt: now.toISOString(),
        score: score ? {
            total: score.total,
            level: score.level?.name || null
        } : null,
        data: data
    };
    const blob = new Blob([
        JSON.stringify(backup, null, 2)
    ], {
        type: 'application/json'
    });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `check-up-finanziario-${$915ff4e2eda66ed0$var$formatDateForFilename(now)}.json`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
}
function $915ff4e2eda66ed0$export$588053414608fe9a(file) {
    return new Promise((resolve, reject)=>{
        if (!file) {
            reject(new Error('Nessun file selezionato.'));
            return;
        }
        if (file.size > 2097152) {
            reject(new Error("Il file \xe8 troppo grande per essere un backup del check-up."));
            return;
        }
        const reader = new FileReader();
        reader.onerror = ()=>reject(new Error("Non \xe8 stato possibile leggere il file."));
        reader.onload = ()=>{
            let parsed;
            try {
                parsed = JSON.parse(String(reader.result));
            } catch (error) {
                reject(new Error("Questo file non \xe8 leggibile: assicurati di caricare il .json scaricato dal check-up."));
                return;
            }
            if (!parsed || parsed.app !== $915ff4e2eda66ed0$var$APP_ID || !parsed.data || typeof parsed.data !== 'object') {
                reject(new Error('Questo non sembra un backup del check-up finanziario di Stipendee.'));
                return;
            }
            if (Number(parsed.schema) > $915ff4e2eda66ed0$var$SCHEMA) {
                reject(new Error("Questo backup \xe8 stato creato con una versione pi\xf9 recente del check-up."));
                return;
            }
            resolve({
                data: parsed.data,
                score: parsed.score || null,
                savedAt: parsed.savedAt || null
            });
        };
        reader.readAsText(file);
    });
}
function $915ff4e2eda66ed0$export$5f15fc6b1108a9e7(iso) {
    if (!iso) return null;
    const date = new Date(iso);
    if (Number.isNaN(date.getTime())) return null;
    return new Intl.DateTimeFormat('it-IT', {
        day: 'numeric',
        month: 'long',
        year: 'numeric'
    }).format(date);
}

});

parcelRegister("bdDJG", function(module, exports) {

$parcel$export(module.exports, "cite", () => $82afbb53527559b9$export$3035df57df42c31a);
$parcel$export(module.exports, "encodeParams", () => $82afbb53527559b9$export$59238e610c6e598a);
$parcel$export(module.exports, "decodeParams", () => $82afbb53527559b9$export$97115bd97c8d9512);
$parcel$export(module.exports, "euro", () => $82afbb53527559b9$export$5f3ae8fddd6f62ab);
$parcel$export(module.exports, "percent", () => $82afbb53527559b9$export$626336c2cd4b14de);
$parcel$export(module.exports, "formatRate", () => $82afbb53527559b9$export$5ad9f64d1b96353b);
$parcel$export(module.exports, "percentPrecise", () => $82afbb53527559b9$export$182ed6183b49524c);
$parcel$export(module.exports, "clampNumber", () => $82afbb53527559b9$export$d8bb65601c55995);
$parcel$export(module.exports, "formatMonthsLabel", () => $82afbb53527559b9$export$297a414ae459377e);
$parcel$export(module.exports, "escapeHtml", () => $82afbb53527559b9$export$4cf11838cdc2a8a8);
$parcel$export(module.exports, "comparisonTable", () => $82afbb53527559b9$export$d978fa30aeff199f);
// Helper condivisi del Check-up finanziario: formattazione, escape,
// serializzazione dello stato nell'URL (?d=) e fonti citate nei contenuti.
// Modulo senza DOM: importabile anche dai test Node.
// Fonti dei dati citati nella parte educativa. Ogni numero nel testo deve essere
// verificabile qui: se una cifra non si trova nella fonte, va tolta, non arrotondata.
const $82afbb53527559b9$var$SOURCES = {
    istat: 'https://www.istat.it/wp-content/uploads/2024/05/Capitolo-2.pdf',
    ocse: 'https://www.oecd.org/content/dam/oecd/en/publications/reports/2023/12/oecd-infe-2023-international-survey-of-adult-financial-literacy_8ce94e2c/56003a32-en.pdf',
    eurostat: 'https://ec.europa.eu/eurostat/databrowser/view/ilc_mdes04/default/table?lang=it',
    bankitalia: 'https://www.bancaditalia.it/pubblicazioni/indagine-famiglie/bil-fam2022/index.html',
    vanguard: 'https://corporate.vanguard.com/content/corporatesite/us/en/corp/articles/emergency-savings-may-hold-key-financial-well-being.html',
    jpmci: 'https://www.jpmorganchase.com/institute/research/household-income-spending/report-weathering-volatility-2'
};
function $82afbb53527559b9$export$3035df57df42c31a(key, label) {
    return `<a href="${$82afbb53527559b9$var$SOURCES[key]}" target="_blank" rel="noopener">${label}</a>`;
}
const $82afbb53527559b9$export$59238e610c6e598a = (obj)=>{
    try {
        return btoa(encodeURIComponent(JSON.stringify(obj)));
    } catch (error) {
        console.error('encodeParams failed', error);
        return null;
    }
};
const $82afbb53527559b9$export$97115bd97c8d9512 = (encoded)=>{
    try {
        return JSON.parse(decodeURIComponent(atob(encoded)));
    } catch (error) {
        console.error('decodeParams failed', error);
        return null;
    }
};
const $82afbb53527559b9$var$euroFormatter = (()=>{
    try {
        return new Intl.NumberFormat('it-IT', {
            style: 'currency',
            currency: 'EUR',
            maximumFractionDigits: 0,
            useGrouping: 'always'
        });
    } catch (error) {
        return new Intl.NumberFormat('it-IT', {
            style: 'currency',
            currency: 'EUR',
            maximumFractionDigits: 0
        });
    }
})();
const $82afbb53527559b9$export$5f3ae8fddd6f62ab = (value)=>$82afbb53527559b9$var$euroFormatter.format(Number.isFinite(value) ? value : 0);
const $82afbb53527559b9$export$626336c2cd4b14de = (value)=>`${Math.round(Number.isFinite(value) ? value : 0)}%`;
const $82afbb53527559b9$export$5ad9f64d1b96353b = (value)=>`${String(Number((Number.isFinite(value) ? value : 0).toFixed(2))).replace('.', ',')}%`;
const $82afbb53527559b9$export$182ed6183b49524c = (value, decimals = 1)=>`${(Number.isFinite(value) ? value : 0).toFixed(decimals).replace('.', ',')}%`;
function $82afbb53527559b9$export$d8bb65601c55995(value, fallback = 0) {
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : fallback;
}
const $82afbb53527559b9$export$297a414ae459377e = (months)=>months === 1 ? '1 mese' : `${String(months).replace('.', ',')} mesi`;
const $82afbb53527559b9$export$4cf11838cdc2a8a8 = (value)=>String(value).replace(/[&<>"']/g, (c)=>({
            '&': '&amp;',
            '<': '&lt;',
            '>': '&gt;',
            '"': '&quot;',
            "'": '&#39;'
        })[c]);
/**
 * Tabella di confronto con celle etichettate per il card-mode mobile (≤768px).
 * columns: [{ header, wide?, inline? }]; la prima colonna è l'intestazione di
 * riga e non riceve data-label. rows: array di array di celle (HTML già pronto).
 * Tenere colonne e celle allineate qui è il punto: header e data-label non
 * possono più divergere.
 */ const $82afbb53527559b9$export$d978fa30aeff199f = (columns, rows)=>{
    const head = columns.map((column)=>`<th>${column.header}</th>`).join('');
    const body = rows.map((cells)=>`<tr>${cells.map((cell, index)=>{
            if (index === 0) return `<td>${cell}</td>`;
            const column = columns[index];
            return `<td data-label="${column.header}"${column.wide ? ' data-wide' : ''}${column.inline ? ' data-inline' : ''}>${cell}</td>`;
        }).join('')}</tr>`).join('\n          ');
    return `<div class="finance-table-scroll"><table class="finance-comparison-table">
        <thead>
          <tr>${head}</tr>
        </thead>
        <tbody>
          ${body}
        </tbody>
      </table></div>`;
};

});

parcelRegister("6YR52", function(module, exports) {

$parcel$export(module.exports, "getEssentialExpenses", () => $5151854d1465ccaf$export$96eccfdeca59400c);
$parcel$export(module.exports, "getMonthlyExpenses", () => $5151854d1465ccaf$export$6067b10612da41ca);
$parcel$export(module.exports, "normalizeAccounts", () => $5151854d1465ccaf$export$a0581eaa9903f543);
$parcel$export(module.exports, "getCheckingAccounts", () => $5151854d1465ccaf$export$61c5c4f75131c04b);
$parcel$export(module.exports, "getCheckingBalance", () => $5151854d1465ccaf$export$bd64c3cff6c9a648);
$parcel$export(module.exports, "getCashFlow", () => $5151854d1465ccaf$export$25b9e0512b598c0f);
$parcel$export(module.exports, "getSavingsRate", () => $5151854d1465ccaf$export$376c925e3f90f893);
$parcel$export(module.exports, "LIQUIDITY_ALLOWED_MONTHS", () => $5151854d1465ccaf$export$14de5794db8077b9);
$parcel$export(module.exports, "getSuggestedLiquidityMonths", () => $5151854d1465ccaf$export$644e5239d2c8a33d);
$parcel$export(module.exports, "getChosenLiquidityMonths", () => $5151854d1465ccaf$export$ebe0543202da3293);
$parcel$export(module.exports, "getOperationalLiquidityTarget", () => $5151854d1465ccaf$export$d80ea2da88b88d0c);
$parcel$export(module.exports, "getOperationalLiquidityRule", () => $5151854d1465ccaf$export$9eb6d176f3bc3a9e);
$parcel$export(module.exports, "buildLiquidityMonthsHint", () => $5151854d1465ccaf$export$2a9d05bd85e2600);
$parcel$export(module.exports, "EMERGENCY_FIRST_MILESTONE", () => $5151854d1465ccaf$export$c25d886fb123d323);
$parcel$export(module.exports, "buildEmergencyMonthsHint", () => $5151854d1465ccaf$export$79399ceb118f9a03);
$parcel$export(module.exports, "getSuggestedEmergencyMonths", () => $5151854d1465ccaf$export$74d722a10c35d71c);
$parcel$export(module.exports, "getChosenEmergencyMonths", () => $5151854d1465ccaf$export$84d4095388a44ff1);
$parcel$export(module.exports, "getEmergencyFundMonths", () => $5151854d1465ccaf$export$536a7ec2271cf81b);
$parcel$export(module.exports, "getEmergencyFundRule", () => $5151854d1465ccaf$export$f4dfd234fa9a4a13);
$parcel$export(module.exports, "getEmergencyFundTarget", () => $5151854d1465ccaf$export$30c7e118c8f4b23c);
$parcel$export(module.exports, "getDeposits", () => $5151854d1465ccaf$export$ff94d6ea7dbc5f35);
$parcel$export(module.exports, "getEmergencyMilestones", () => $5151854d1465ccaf$export$36cf2d42de4cf3d1);
$parcel$export(module.exports, "DEPOSIT_TYPE_LABELS", () => $5151854d1465ccaf$export$dbe0d9325ad4387d);
$parcel$export(module.exports, "normalizeDeposits", () => $5151854d1465ccaf$export$2cf6570d151ba49c);
$parcel$export(module.exports, "getTotalDepositBalance", () => $5151854d1465ccaf$export$2a7b52bce05aca00);
$parcel$export(module.exports, "normalizeGoals", () => $5151854d1465ccaf$export$c2e6bd574c9b8a58);
$parcel$export(module.exports, "lowerInstrument", () => $5151854d1465ccaf$export$94f35dad18a9751d);
$parcel$export(module.exports, "formatIdleSources", () => $5151854d1465ccaf$export$367739d89834ce60);
$parcel$export(module.exports, "formatGoalHorizon", () => $5151854d1465ccaf$export$aca044a98be75fce);
$parcel$export(module.exports, "computePlan", () => $5151854d1465ccaf$export$937499e792d12a74);
// Motore di calcolo del Check-up finanziario: da un oggetto dati (le risposte
// del wizard) deriva metriche, warning, piano d'azione, pagella e contenuti.
// Modulo puro, senza DOM: computePlan(data) e' l'ingresso principale ed e'
// importabile anche dai test Node (tests/checkup-engine.test.js).

var $bdDJG = parcelRequire("bdDJG");
// Imposta di bollo: fissa sul conto corrente sopra la soglia di giacenza media,
// proporzionale su conti deposito e strumenti finanziari. Le stesse cifre
// compaiono anche nella copy educativa: se cambiano, grep di "34,20" e "0,20".
const $5151854d1465ccaf$var$STAMP_DUTY_ACCOUNT = 34.20;
const $5151854d1465ccaf$var$STAMP_DUTY_ACCOUNT_THRESHOLD = 5000;
const $5151854d1465ccaf$var$STAMP_DUTY_PRODUCTS_RATE = 0.002;
function $5151854d1465ccaf$var$getMarginalTaxRate(ral) {
    const amount = (0, $bdDJG.clampNumber)(ral);
    if (amount <= 0) return null;
    if (amount <= 28000) return 23;
    if (amount <= 50000) return 35;
    return 43;
}
function $5151854d1465ccaf$var$getWorkStability(workStatus) {
    if (workStatus === 'employee_permanent' || workStatus === 'retired') return 'high';
    if (workStatus === 'employee_fixed' || workStatus === 'freelancer') return 'medium';
    return 'low';
}
function $5151854d1465ccaf$export$96eccfdeca59400c(data) {
    if (data.expenseEssential !== undefined && data.expenseEssential !== null && data.expenseEssential !== '') return (0, $bdDJG.clampNumber)(data.expenseEssential);
    // Retrocompatibilità con i dati salvati/condivisi prima dello split necessarie/discrezionali
    return (0, $bdDJG.clampNumber)(data.expenseHousing) + (0, $bdDJG.clampNumber)(data.expenseBills) + (0, $bdDJG.clampNumber)(data.expenseGroceries) + (0, $bdDJG.clampNumber)(data.expenseTransport) + (0, $bdDJG.clampNumber)(data.expenseOther);
}
function $5151854d1465ccaf$var$getDiscretionaryExpenses(data) {
    return (0, $bdDJG.clampNumber)(data.expenseDiscretionary);
}
function $5151854d1465ccaf$export$6067b10612da41ca(data) {
    return $5151854d1465ccaf$export$96eccfdeca59400c(data) + $5151854d1465ccaf$var$getDiscretionaryExpenses(data);
}
function $5151854d1465ccaf$export$a0581eaa9903f543(rawAccounts = []) {
    return rawAccounts.map((account)=>({
            label: `${account.label || ''}`.trim(),
            balance: (0, $bdDJG.clampNumber)(account.balance),
            interestRate: (0, $bdDJG.clampNumber)(account.interestRate)
        })).filter((account)=>account.label || account.balance > 0 || account.interestRate > 0);
}
function $5151854d1465ccaf$export$61c5c4f75131c04b(data) {
    if (Array.isArray(data.accounts) && data.accounts.length > 0) return $5151854d1465ccaf$export$a0581eaa9903f543(data.accounts);
    const legacyBalance = (0, $bdDJG.clampNumber)(data.checkingBalance);
    const legacyRate = data.checkingInterest === 'yes_small' ? 2 : 0;
    if (legacyBalance > 0 || legacyRate > 0) return [
        {
            label: 'Conto principale',
            balance: legacyBalance,
            interestRate: legacyRate
        }
    ];
    return [];
}
function $5151854d1465ccaf$export$bd64c3cff6c9a648(data) {
    const accounts = $5151854d1465ccaf$export$61c5c4f75131c04b(data);
    if (accounts.length > 0) return accounts.reduce((sum, account)=>sum + account.balance, 0);
    return (0, $bdDJG.clampNumber)(data.checkingBalance);
}
function $5151854d1465ccaf$var$getCheckingInterestProfile(data) {
    const accounts = $5151854d1465ccaf$export$61c5c4f75131c04b(data);
    if (accounts.length > 0) return accounts.some((account)=>account.interestRate > 0) ? 'yes_small' : 'no';
    return data.checkingInterest || 'no';
}
function $5151854d1465ccaf$export$25b9e0512b598c0f(data) {
    return (0, $bdDJG.clampNumber)(data.monthlyIncome) - $5151854d1465ccaf$export$6067b10612da41ca(data);
}
function $5151854d1465ccaf$export$376c925e3f90f893(data) {
    const income = (0, $bdDJG.clampNumber)(data.monthlyIncome);
    if (income <= 0) return 0;
    return $5151854d1465ccaf$export$25b9e0512b598c0f(data) / income * 100;
}
function $5151854d1465ccaf$var$getLiquidityMonths(data) {
    const expenses = $5151854d1465ccaf$export$6067b10612da41ca(data);
    if (expenses <= 0) return null;
    return $5151854d1465ccaf$export$bd64c3cff6c9a648(data) / expenses;
}
// Anche la liquidità è una forbice personale (il corso dice "1-3 mesi, variabile
// per stile di vita"): noi suggeriamo, l'utente può scegliere tra questi valori.
const $5151854d1465ccaf$export$14de5794db8077b9 = [
    1,
    1.5,
    2,
    3
];
/** I mesi di liquidità suggeriti dal profilo. Entrate irregolari o persone a carico
 *  spingono a 2: il conto deve assorbire incassi che tardano e imprevisti quotidiani. */ function $5151854d1465ccaf$export$644e5239d2c8a33d(data) {
    if (data.familyStatus === 'parents' || data.housingStatus === 'parents_house') return 1;
    if (data.workStatus === 'freelancer' || (0, $bdDJG.clampNumber)(data.dependents) > 0 || data.familyStatus === 'with_children') return 2;
    return 1.5;
}
/** I mesi di liquidità scelti esplicitamente dall'utente, o null se si affida al consiglio. */ function $5151854d1465ccaf$export$ebe0543202da3293(data) {
    const chosen = (0, $bdDJG.clampNumber)(data.liquidityTargetMonths);
    return $5151854d1465ccaf$export$14de5794db8077b9.includes(chosen) ? chosen : null;
}
function $5151854d1465ccaf$var$getOperationalLiquidityTargetMonths(data) {
    const chosen = $5151854d1465ccaf$export$ebe0543202da3293(data);
    return chosen !== null ? chosen : $5151854d1465ccaf$export$644e5239d2c8a33d(data);
}
function $5151854d1465ccaf$export$d80ea2da88b88d0c(data) {
    const expenses = $5151854d1465ccaf$export$6067b10612da41ca(data);
    if (expenses <= 0) return 0;
    return expenses * $5151854d1465ccaf$var$getOperationalLiquidityTargetMonths(data);
}
function $5151854d1465ccaf$export$9eb6d176f3bc3a9e(data) {
    const chosen = $5151854d1465ccaf$export$ebe0543202da3293(data);
    const suggested = $5151854d1465ccaf$export$644e5239d2c8a33d(data);
    if (chosen !== null && chosen !== suggested) return {
        months: chosen,
        reason: chosen < suggested ? `hai scelto tu di tenerne ${(0, $bdDJG.formatMonthsLabel)(chosen)}; per il tuo profilo ne suggeriamo ${(0, $bdDJG.formatMonthsLabel)(suggested)}, quindi valuta se salire` : `hai scelto tu di tenerne ${(0, $bdDJG.formatMonthsLabel)(chosen)}; per il tuo profilo ne basterebbero ${(0, $bdDJG.formatMonthsLabel)(suggested)}, ma un margine in pi\xf9 non \xe8 un errore: la liquidit\xe0 non deve rendere, deve esserci quando serve`
    };
    if (data.familyStatus === 'parents' || data.housingStatus === 'parents_house') return {
        months: 1,
        reason: 'vivendo con i genitori le spese sono leggere e basta poco'
    };
    if (data.workStatus === 'freelancer') return {
        months: 2,
        reason: 'con entrate irregolari il conto deve assorbire anche i mesi in cui gli incassi tardano'
    };
    if ((0, $bdDJG.clampNumber)(data.dependents) > 0 || data.familyStatus === 'with_children') return {
        months: 2,
        reason: "con persone a carico serve pi\xf9 tolleranza per gli imprevisti di liquidit\xe0"
    };
    return {
        months: 1.5,
        reason: 'abbastanza per coprire il mese corrente, gli addebiti e i piccoli scostamenti'
    };
}
/** Spiega in poche righe perché suggeriamo proprio quel numero di mesi liquidi. */ function $5151854d1465ccaf$export$2a9d05bd85e2600(data) {
    const suggested = $5151854d1465ccaf$export$644e5239d2c8a33d(data);
    if (suggested === 1) return 'Vivendo con i genitori le spese sono leggere: ti basta circa un mese di spese sul conto. Tra 1 e 3 mesi va bene: quello che avanza merita un compito, come emergenze o spese previste, e possibilmente un conto che rende.';
    const factors = [];
    if (data.workStatus === 'freelancer') factors.push('entrate irregolari da lavoro autonomo, che possono tardare');
    if ((0, $bdDJG.clampNumber)(data.dependents) > 0 || data.familyStatus === 'with_children') factors.push('persone a carico, che portano imprevisti quotidiani');
    const base = factors.length === 0 ? `Ti suggeriamo ${(0, $bdDJG.formatMonthsLabel)(suggested)}: con entrate regolari basta coprire il mese corrente, gli addebiti e i piccoli scostamenti.` : `Ti suggeriamo ${(0, $bdDJG.formatMonthsLabel)(suggested)}: ${factors.join('; ')}.`;
    return `${base} Tra 1 e 3 mesi va bene: quello che avanza merita un compito, come emergenze o spese previste, e possibilmente un conto che rende. Sopra i 5.000 \u{20AC} di giacenza media sul conto, in pi\xf9, paghi il bollo da 34,20 \u{20AC}.`;
}
// Primo traguardo: la soglia della "spesa imprevista" con cui Istat ed Eurostat
// misurano la fragilità finanziaria (circa 1.000 euro in Italia). È lo scalino che
// porta il grosso del beneficio, secondo la ricerca Vanguard su 12.400 investitori.
const $5151854d1465ccaf$export$c25d886fb123d323 = 1000;
// Base: 3 mesi, la soglia con cui l'OCSE misura la resilienza finanziaria delle famiglie.
const $5151854d1465ccaf$var$EMERGENCY_BASE_MONTHS = 3;
/** Il nucleo dipende da una sola entrata? È il fattore che pesa di più: se quella si
 *  ferma non c'è un secondo reddito che continua a pagare le spese fisse. */ function $5151854d1465ccaf$var$isSoleEarnerHousehold(data) {
    const sharedHousehold = [
        'couple',
        'with_children',
        'separated'
    ].includes(data.familyStatus);
    return sharedHousehold && data.householdEarners === 'one';
}
/** I fattori che alzano il target, uno alla volta e spiegabili. */ function $5151854d1465ccaf$var$getEmergencyRiskFactors(data) {
    const factors = [];
    if (data.workStatus === 'freelancer') {
        // Doppio motivo, e conta doppio: reddito più variabile e nessuna rete paragonabile.
        factors.push(`il reddito da lavoro autonomo \xe8 pi\xf9 variabile (secondo ${(0, $bdDJG.cite)('istat', 'Istat')} il rischio di povert\xe0 tra gli autonomi \xe8 del 17%, contro l'8,5% dei dipendenti a tempo indeterminato)`);
        factors.push("e se il lavoro si ferma non c'\xe8 una NASpI a fare da ammortizzatore, come per un dipendente");
    } else if (data.workStatus === 'employee_fixed') factors.push(`il contratto \xe8 a termine, e secondo ${(0, $bdDJG.cite)('istat', 'Istat')} il rischio di povert\xe0 per i dipendenti a tempo determinato \xe8 del 16,2%, il doppio di chi ha un tempo indeterminato (8,5%)`);
    else if (data.workStatus === 'student' || data.workStatus === 'unemployed') factors.push("oggi non c'\xe8 un reddito da lavoro stabile su cui contare, quindi il cuscinetto deve reggere pi\xf9 a lungo");
    if ((0, $bdDJG.clampNumber)(data.dependents) > 0 || data.familyStatus === 'with_children') factors.push('ci sono persone che dipendono da te, quindi un imprevisto non colpisce solo te');
    if ($5151854d1465ccaf$var$isSoleEarnerHousehold(data)) factors.push("il nucleo si regge su una sola entrata: se salta quella non c'\xe8 una seconda a fare da rete");
    return factors;
}
// L'utente può scegliere quanti mesi coprire: 3-9 va bene, fino a 12 è accettabile.
const $5151854d1465ccaf$var$EMERGENCY_MIN_MONTHS = 3;
const $5151854d1465ccaf$var$EMERGENCY_MAX_MONTHS = 12;
/** Versione compatta dei fattori di rischio, per gli hint dove serve brevità. */ function $5151854d1465ccaf$var$getEmergencyRiskFactorsShort(data) {
    const factors = [];
    if (data.workStatus === 'freelancer') factors.push("reddito da lavoro autonomo, pi\xf9 variabile e senza NASpI (conta doppio)");
    else if (data.workStatus === 'employee_fixed') factors.push('contratto a termine');
    else if (data.workStatus === 'student' || data.workStatus === 'unemployed') factors.push('oggi nessun reddito da lavoro stabile');
    if ((0, $bdDJG.clampNumber)(data.dependents) > 0 || data.familyStatus === 'with_children') factors.push('persone a carico');
    if ($5151854d1465ccaf$var$isSoleEarnerHousehold(data)) factors.push('una sola entrata nel nucleo');
    return factors;
}
/** Spiega in poche righe perché suggeriamo proprio quel numero di mesi. */ function $5151854d1465ccaf$export$79399ceb118f9a03(data) {
    const suggested = $5151854d1465ccaf$export$74d722a10c35d71c(data);
    if (suggested === 0.5) return "Vivendo con i genitori le spese fisse sono minime e la rete di sicurezza \xe8 gi\xe0 l\xec: ti basta un piccolo cuscinetto. Se preferisci pi\xf9 margine, tra 3 e 9 mesi va bene e fino a 12 \xe8 accettabile.";
    const factors = $5151854d1465ccaf$var$getEmergencyRiskFactorsShort(data);
    const base = factors.length === 0 ? `Ti suggeriamo ${suggested} mesi, il riferimento di base: nel tuo profilo non c'\xe8 nessun fattore che richieda pi\xf9 margine (reddito stabile, nessun carico che pesi solo su di te).` : `Ti suggeriamo ${suggested} mesi: si parte da 3 e si sale di uno per ogni fattore di rischio. Nel tuo caso: ${factors.join('; ')}.`;
    return `${base} Tra 3 e 9 mesi va bene, fino a 12 \xe8 accettabile: oltre, \xe8 pi\xf9 sicurezza di quanta te ne serva, e a quei soldi conviene dare un compito diverso.`;
}
/** I mesi che suggeriamo noi dal profilo: base 3, +1 per fattore di rischio, tetto 6. */ function $5151854d1465ccaf$export$74d722a10c35d71c(data) {
    if (data.familyStatus === 'parents' || data.housingStatus === 'parents_house') return 0.5;
    return Math.min($5151854d1465ccaf$var$EMERGENCY_BASE_MONTHS + $5151854d1465ccaf$var$getEmergencyRiskFactors(data).length, 6);
}
/** I mesi scelti esplicitamente dall'utente, o null se si affida al consiglio. */ function $5151854d1465ccaf$export$84d4095388a44ff1(data) {
    const chosen = (0, $bdDJG.clampNumber)(data.emergencyMonths);
    return chosen >= $5151854d1465ccaf$var$EMERGENCY_MIN_MONTHS && chosen <= $5151854d1465ccaf$var$EMERGENCY_MAX_MONTHS ? chosen : null;
}
function $5151854d1465ccaf$export$536a7ec2271cf81b(data) {
    const chosen = $5151854d1465ccaf$export$84d4095388a44ff1(data);
    return chosen !== null ? chosen : $5151854d1465ccaf$export$74d722a10c35d71c(data);
}
function $5151854d1465ccaf$export$f4dfd234fa9a4a13(data) {
    const chosen = $5151854d1465ccaf$export$84d4095388a44ff1(data);
    const suggested = $5151854d1465ccaf$export$74d722a10c35d71c(data);
    if (chosen !== null && chosen !== suggested) {
        const suggestedLabel = suggested === 0.5 ? 'quasi zero' : `${suggested} mesi`;
        return {
            months: chosen,
            reason: chosen < suggested ? `hai scelto tu di coprire ${chosen} mesi; per il tuo profilo ne suggeriamo ${suggestedLabel}, quindi valuta se salire verso quel numero` : `hai scelto tu di coprire ${chosen} mesi; per il tuo profilo ne basterebbero ${suggestedLabel}, ma un margine in pi\xf9 va benissimo`
        };
    }
    if (data.familyStatus === 'parents' || data.housingStatus === 'parents_house') return {
        months: 0.5,
        reason: "vivendo con i genitori le spese fisse sono minime e la rete di sicurezza \xe8 gi\xe0 l\xec"
    };
    const factors = $5151854d1465ccaf$var$getEmergencyRiskFactors(data);
    const months = $5151854d1465ccaf$export$536a7ec2271cf81b(data);
    if (factors.length === 0) return {
        months: months,
        reason: `tre mesi \xe8 il riferimento di base, quello con cui l'${(0, $bdDJG.cite)('ocse', 'OCSE')} misura se una famiglia regge uno stop del reddito`
    };
    return {
        months: months,
        reason: `si parte da tre mesi e si sale per un motivo alla volta: ${factors.join('; ')}`
    };
}
function $5151854d1465ccaf$export$30c7e118c8f4b23c(data) {
    // Il target si calcola sulle spese totali: è la definizione con cui l'OCSE misura
    // la resilienza ("coprire le spese per tre mesi senza l'entrata principale") ed è
    // più prudente. Nessun tetto massimo in euro: penalizzerebbe chi ha spese alte.
    const target = $5151854d1465ccaf$export$6067b10612da41ca(data) * $5151854d1465ccaf$export$536a7ec2271cf81b(data);
    return Math.max(target, $5151854d1465ccaf$export$c25d886fb123d323);
}
/** Somma della composizione del fondo spezzato ({accounts: {i: importo}, deposits: {...}, other}). */ function $5151854d1465ccaf$export$a757e2f826c773d(split) {
    if (!split) return 0;
    const sumMap = (map)=>Object.values(map || {}).reduce((sum, value)=>sum + (0, $bdDJG.clampNumber)(value), 0);
    return sumMap(split.accounts) + sumMap(split.deposits) + (0, $bdDJG.clampNumber)(split.other);
}
/** Composizione del fondo spezzato arricchita con le proprietà di ogni posto. */ function $5151854d1465ccaf$var$buildEmergencySplitDetail(data) {
    const split = data.emergencySplit;
    if (!split) return null;
    const accounts = $5151854d1465ccaf$export$61c5c4f75131c04b(data);
    const deposits = $5151854d1465ccaf$export$ff94d6ea7dbc5f35(data);
    const detail = [];
    Object.entries(split.accounts || {}).forEach(([key, value])=>{
        const amount = (0, $bdDJG.clampNumber)(value);
        if (amount <= 0) return;
        const account = accounts[Number(key)];
        detail.push({
            amount: amount,
            kind: 'account',
            label: account?.label || `Conto ${Number(key) + 1}`,
            yields: (account?.interestRate || 0) > 0,
            accessible: true
        });
    });
    Object.entries(split.deposits || {}).forEach(([key, value])=>{
        const amount = (0, $bdDJG.clampNumber)(value);
        if (amount <= 0) return;
        const deposit = deposits[Number(key)];
        detail.push({
            amount: amount,
            kind: 'deposit',
            label: deposit?.label || `Deposito ${Number(key) + 1}`,
            yields: true,
            accessible: deposit?.type !== 'bound'
        });
    });
    if ((0, $bdDJG.clampNumber)(split.other) > 0) detail.push({
        amount: (0, $bdDJG.clampNumber)(split.other),
        kind: 'other',
        label: 'altrove',
        yields: null,
        accessible: true
    });
    return detail.length ? detail : null;
}
/** I traguardi intermedi: si arriva al fondo pieno un gradino alla volta. */ function $5151854d1465ccaf$export$36cf2d42de4cf3d1(data) {
    const monthly = $5151854d1465ccaf$export$6067b10612da41ca(data);
    const months = $5151854d1465ccaf$export$536a7ec2271cf81b(data);
    const full = $5151854d1465ccaf$export$30c7e118c8f4b23c(data);
    const milestones = [
        {
            key: 'first',
            label: 'Il primo mattone',
            amount: $5151854d1465ccaf$export$c25d886fb123d323,
            note: `Copre la spesa imprevista tipica: un guasto, un dentista, una riparazione. \xc8 il gradino che cambia di pi\xf9 le cose: una ricerca ${(0, $bdDJG.cite)('vanguard', 'Vanguard')} su 12.400 investitori ha misurato che i primi 2.000 dollari messi da parte migliorano il benessere finanziario pi\xf9 di tutto quello che si accumula dopo.`
        }
    ];
    const cushion = monthly * $5151854d1465ccaf$var$EMERGENCY_BASE_MONTHS;
    if (cushion > $5151854d1465ccaf$export$c25d886fb123d323 && cushion <= full) milestones.push({
        key: 'cushion',
        label: 'Il cuscinetto',
        amount: cushion,
        note: `Tre mesi di spese: \xe8 la soglia con cui l'${(0, $bdDJG.cite)('ocse', 'OCSE')} misura se una famiglia regge uno stop del reddito.`
    });
    if (full > cushion && months > $5151854d1465ccaf$var$EMERGENCY_BASE_MONTHS) milestones.push({
        key: 'full',
        label: 'Il fondo pieno',
        amount: full,
        note: $5151854d1465ccaf$export$84d4095388a44ff1(data) !== null ? `${months} mesi di spese: la copertura che hai scelto tu.` : `${months} mesi: nel tuo caso serve pi\xf9 margine della media.`
    });
    return milestones.filter((milestone, index, all)=>index === 0 || milestone.amount > all[index - 1].amount);
}
function $5151854d1465ccaf$var$getInvestments(data) {
    return {
        stocks: (0, $bdDJG.clampNumber)(data.investStocks),
        etf: (0, $bdDJG.clampNumber)(data.investEtf),
        moneyMarket: (0, $bdDJG.clampNumber)(data.investMoneyMarket),
        funds: (0, $bdDJG.clampNumber)(data.investFunds),
        bonds: (0, $bdDJG.clampNumber)(data.investBonds),
        postalBonds: (0, $bdDJG.clampNumber)(data.investPostalBonds),
        crypto: (0, $bdDJG.clampNumber)(data.investCrypto),
        cash: (0, $bdDJG.clampNumber)(data.investCash),
        cashRate: (0, $bdDJG.clampNumber)(data.investCashRate),
        deposit: (0, $bdDJG.clampNumber)(data.investDeposit),
        // Vale solo se una polizza e' dichiarata: un importo residuo senza la
        // risposta "si'" non deve entrare nel patrimonio
        lifeInsurance: $5151854d1465ccaf$var$getLifeInsurance(data).value
    };
}
const $5151854d1465ccaf$var$LIFE_INSURANCE_KINDS = [
    'guaranteed',
    'unit_linked',
    'unknown'
];
/**
 * La polizza di risparmio nel modello dei compiti: la natura decide il posto.
 * Ramo I / gestione separata e' capitale prudente (copre spese oltre i 3 anni,
 * per ultima: il riscatto ha attriti); la unit-linked oscilla ed e' lungo
 * termine; chi non sa cosa ha firmato conta nel patrimonio ma non copre nulla.
 */ function $5151854d1465ccaf$var$getLifeInsurance(data) {
    const kind = $5151854d1465ccaf$var$LIFE_INSURANCE_KINDS.includes(data.lifeInsurance) ? data.lifeInsurance : 'none';
    const value = kind === 'none' ? 0 : (0, $bdDJG.clampNumber)(data.lifeInsuranceValue);
    return {
        kind: kind,
        value: value,
        prudent: kind === 'guaranteed' ? value : 0,
        longTerm: kind === 'unit_linked' ? value : 0,
        unknown: kind === 'unknown' ? value : 0
    };
}
const $5151854d1465ccaf$export$dbe0d9325ad4387d = {
    free: 'libero',
    withdrawable: 'svincolabile',
    bound: 'vincolato'
};
// Ordine di accessibilità: si intacca prima ciò che è più accessibile
const $5151854d1465ccaf$var$DEPOSIT_ACCESS_ORDER = {
    free: 0,
    withdrawable: 1,
    bound: 2
};
function $5151854d1465ccaf$export$2cf6570d151ba49c(rawDeposits = []) {
    return rawDeposits.map((deposit)=>({
            label: `${deposit.label || ''}`.trim(),
            balance: (0, $bdDJG.clampNumber)(deposit.balance),
            type: [
                'free',
                'withdrawable',
                'bound'
            ].includes(deposit.type) ? deposit.type : 'free',
            rate: (0, $bdDJG.clampNumber)(deposit.rate),
            monthsToMaturity: deposit.monthsToMaturity === '' || deposit.monthsToMaturity === null || deposit.monthsToMaturity === undefined ? null : (0, $bdDJG.clampNumber)(deposit.monthsToMaturity)
        })).filter((deposit)=>deposit.label || deposit.balance > 0);
}
function $5151854d1465ccaf$export$ff94d6ea7dbc5f35(data) {
    if (Array.isArray(data.deposits) && data.deposits.length > 0) return $5151854d1465ccaf$export$2cf6570d151ba49c(data.deposits);
    // Retrocompatibilità: vecchio modello a deposito singolo
    const legacyBalance = (0, $bdDJG.clampNumber)(data.depositAccountBalance);
    if (data.depositAccountType && data.depositAccountType !== 'no' && legacyBalance > 0) return [
        {
            label: 'Conto deposito',
            balance: legacyBalance,
            type: [
                'free',
                'withdrawable',
                'bound'
            ].includes(data.depositAccountType) ? data.depositAccountType : 'free',
            rate: 0,
            monthsToMaturity: null
        }
    ];
    return [];
}
function $5151854d1465ccaf$export$2a7b52bce05aca00(data) {
    const deposits = $5151854d1465ccaf$export$ff94d6ea7dbc5f35(data);
    if (deposits.length > 0) return deposits.reduce((sum, deposit)=>sum + deposit.balance, 0);
    return (0, $bdDJG.clampNumber)(data.investDeposit);
}
function $5151854d1465ccaf$var$getMainDepositType(deposits) {
    if (!deposits.length) return null;
    const largest = deposits.reduce((best, deposit)=>deposit.balance > best.balance ? deposit : best, deposits[0]);
    return largest.type;
}
function $5151854d1465ccaf$var$getDebts(data) {
    return [
        {
            key: 'mortgage',
            label: 'Mutuo',
            amount: (0, $bdDJG.clampNumber)(data.debtMortgageAmount),
            rate: (0, $bdDJG.clampNumber)(data.debtMortgageRate)
        },
        {
            key: 'personal',
            label: 'Prestito personale',
            amount: (0, $bdDJG.clampNumber)(data.debtPersonalAmount),
            rate: (0, $bdDJG.clampNumber)(data.debtPersonalRate)
        },
        {
            key: 'revolving',
            label: 'Carta revolving',
            amount: (0, $bdDJG.clampNumber)(data.debtRevolvingAmount),
            rate: (0, $bdDJG.clampNumber)(data.debtRevolvingRate)
        },
        {
            key: 'car',
            label: 'Finanziamento auto',
            amount: (0, $bdDJG.clampNumber)(data.debtCarAmount),
            rate: (0, $bdDJG.clampNumber)(data.debtCarRate)
        }
    ].filter((debt)=>debt.amount > 0);
}
function $5151854d1465ccaf$export$c2e6bd574c9b8a58(rawGoals = []) {
    return rawGoals.map((goal)=>({
            label: `${goal.label || ''}`.trim(),
            amount: (0, $bdDJG.clampNumber)(goal.amount),
            years: (0, $bdDJG.clampNumber)(goal.years)
        })).filter((goal)=>goal.label && goal.amount > 0 && goal.years > 0);
}
function $5151854d1465ccaf$var$getRiskTolerance(data) {
    if (data.reactionDrop === 'sell' || data.checkFrequency === 'daily') return 'low';
    if ((data.reactionDrop === 'buy' || data.reactionDrop === 'ignore') && (data.checkFrequency === 'never' || data.checkFrequency === 'yearly')) return 'high';
    return 'medium';
}
function $5151854d1465ccaf$export$94f35dad18a9751d(label) {
    return label.toLowerCase().replace(/\bbot\b/g, 'BOT').replace(/\bbtp\b/g, 'BTP').replace(/\bcct\b/g, 'CCT').replace(/\betf\b/g, 'ETF');
}
function $5151854d1465ccaf$var$getGoalInstrumentLabel(years) {
    if (years <= 1) return "BOT che scade prima della spesa, un ETF monetario, o liquidit\xe0 che rende: conto remunerato o deposito libero/svincolabile";
    if (years <= 3) return 'Conto deposito (anche vincolato, se scade prima della spesa), BOT od ETF monetario';
    if (years <= 10) return 'BTP o obbligazioni con scadenza vicina alla data della spesa';
    return 'Capitale di lungo termine, tenuto separato dalle spese con una data';
}
/** "2.500 € su Illimity e 1.150 € di cash sul broker": il dettaglio dei soldi fermi. */ function $5151854d1465ccaf$export$367739d89834ce60(sources) {
    return sources.map((source)=>source.broker ? `${(0, $bdDJG.euro)(source.amount)} di cash sul broker` : `${(0, $bdDJG.euro)(source.amount)} su ${source.label}`).join(' e ');
}
function $5151854d1465ccaf$export$aca044a98be75fce(years) {
    const y = (0, $bdDJG.clampNumber)(years);
    if (y > 0 && y < 1) {
        const months = Math.max(Math.round(y * 12), 1);
        return months === 1 ? 'tra 1 mese' : `tra ${months} mesi`;
    }
    if (y === 1) return 'tra 1 anno';
    return `tra ${String(y).replace('.', ',')} anni`;
}
function $5151854d1465ccaf$var$buildGoalCoverage(goals, startingPools) {
    const scalarPools = {
        checking: {
            remaining: startingPools.checking,
            label: "liquidit\xe0 in eccesso"
        },
        broker: {
            remaining: startingPools.brokerCash || 0,
            label: "liquidit\xe0 sul broker"
        },
        moneyMarket: {
            remaining: startingPools.moneyMarket || 0,
            label: 'ETF monetari'
        },
        bonds: {
            remaining: startingPools.bonds,
            label: 'obbligazioni / BOT / BTP'
        },
        postalBonds: {
            remaining: startingPools.postalBonds || 0,
            label: 'buoni fruttiferi postali'
        },
        // Solo la polizza a capitale garantito (ramo I): riscattabile, quindi puo'
        // coprire una spesa, ma con attriti. Si usa per ultima e solo oltre i 3 anni.
        lifeGuaranteed: {
            remaining: startingPools.lifeGuaranteed || 0,
            label: 'polizza a capitale garantito'
        }
    };
    const depositPools = (startingPools.deposits || []).map((deposit)=>({
            ...deposit
        }));
    return goals.map((goal)=>({
            ...goal
        })).sort((first, second)=>first.years - second.years).map((goal)=>{
        const sources = [];
        let remaining = goal.amount;
        const goalMonths = Math.max(Math.round((0, $bdDJG.clampNumber)(goal.years) * 12), 1);
        const drainScalar = (key)=>{
            const pool = scalarPools[key];
            if (remaining <= 0 || pool.remaining <= 0) return;
            const usedAmount = Math.min(pool.remaining, remaining);
            pool.remaining -= usedAmount;
            remaining -= usedAmount;
            sources.push({
                key: key,
                label: pool.label,
                amount: usedAmount
            });
        };
        const drainDeposits = ()=>{
            if (remaining <= 0) return;
            // Un vincolato copre una spesa solo se si svincola prima della data;
            // senza scadenza dichiarata non possiamo contarci.
            const usable = depositPools.filter((deposit)=>deposit.remaining > 0 && (deposit.type !== 'bound' || deposit.monthsToMaturity !== null && deposit.monthsToMaturity <= goalMonths)).sort((a, b)=>$5151854d1465ccaf$var$DEPOSIT_ACCESS_ORDER[b.type] - $5151854d1465ccaf$var$DEPOSIT_ACCESS_ORDER[a.type]);
            usable.forEach((deposit)=>{
                if (remaining <= 0 || deposit.remaining <= 0) return;
                const usedAmount = Math.min(deposit.remaining, remaining);
                deposit.remaining -= usedAmount;
                remaining -= usedAmount;
                sources.push({
                    key: 'deposit',
                    label: `${deposit.label || 'conto deposito'} (${$5151854d1465ccaf$export$dbe0d9325ad4387d[deposit.type]})`,
                    amount: usedAmount
                });
            });
        };
        // I buoni postali sono rimborsabili in ogni momento a capitale garantito:
        // coprono qualsiasi orizzonte, ma dopo i titoli con scadenza (svincolarli
        // presto sacrifica il rendimento a gradini delle serie).
        const order = goal.years <= 1 ? [
            'checking',
            'broker',
            'moneyMarket',
            'deposits',
            'bonds',
            'postalBonds'
        ] : goal.years <= 3 ? [
            'deposits',
            'broker',
            'moneyMarket',
            'bonds',
            'postalBonds',
            'checking'
        ] : [
            'bonds',
            'postalBonds',
            'deposits',
            'broker',
            'moneyMarket',
            'checking',
            'lifeGuaranteed'
        ];
        order.forEach((step)=>step === 'deposits' ? drainDeposits() : drainScalar(step));
        const coveredAmount = goal.amount - remaining;
        return {
            ...goal,
            recommendedInstrument: $5151854d1465ccaf$var$getGoalInstrumentLabel(goal.years),
            coveredAmount: coveredAmount,
            gap: remaining,
            fullyCovered: remaining <= 0,
            coverageRatio: goal.amount > 0 ? coveredAmount / goal.amount : 0,
            sources: sources
        };
    });
}
function $5151854d1465ccaf$var$buildWarnings(data, metrics) {
    const warnings = [];
    const riskyInvestments = metrics.riskyInvestmentsValue;
    const highRateDebt = metrics.debts.find((debt)=>debt.rate > 10);
    if (metrics.cashFlow < 0) warnings.push({
        title: 'Cash flow negativo',
        body: 'Le spese superano le entrate. Prima di parlare di investimenti serve fermare l\'erosione del conto.',
        severity: 'critical'
    });
    else if (metrics.cashFlow === 0) warnings.push({
        title: 'Margine mensile azzerato',
        body: 'Sei in equilibrio fragile: basta una spesa imprevista per rompere il piano.',
        severity: 'warning'
    });
    const discretionary = (0, $bdDJG.clampNumber)(data.expenseDiscretionary);
    const income = (0, $bdDJG.clampNumber)(data.monthlyIncome);
    if (discretionary > 0 && income > 0 && discretionary / income > 0.3) {
        const savingFrom20Cut = Math.round(discretionary * 0.2);
        const weeklyRestaurantCut = Math.round(savingFrom20Cut / 4);
        warnings.push({
            title: 'Spese discrezionali elevate',
            body: `Le spese discrezionali (${(0, $bdDJG.euro)(discretionary)}/mese) rappresentano il ${Math.round(discretionary / income * 100)}% del reddito, sopra il 30%. Se riduci del 20% (${(0, $bdDJG.euro)(savingFrom20Cut)}/mese), equivalgono a circa ${(0, $bdDJG.euro)(weeklyRestaurantCut)}/settimana in meno al ristorante.`,
            severity: 'warning'
        });
    }
    if (metrics.cashFlow <= 0 && discretionary > 0) {
        const potentialRecovery = Math.round(discretionary * 0.3);
        warnings.push({
            title: 'Riduci le spese discrezionali per ripartire',
            body: `Con cash flow ${metrics.cashFlow < 0 ? 'negativo' : 'a zero'}, ridurre le spese discrezionali del 30% recupererebbe circa ${(0, $bdDJG.euro)(potentialRecovery)}/mese. Questo \xe8 il modo pi\xf9 rapido per tornare in positivo senza toccare le spese necessarie.`,
            severity: 'critical'
        });
    }
    if (highRateDebt) warnings.push({
        title: `Fermati: ${highRateDebt.label.toLowerCase()} al ${(0, $bdDJG.percentPrecise)(highRateDebt.rate)}`,
        body: `Questo debito costa pi\xf9 di quanto qualsiasi investimento possa rendere: finch\xe9 esiste, ogni altra strategia \xe8 un controsenso. Estinguerlo equivale a un investimento con rendimento garantito del ${(0, $bdDJG.percentPrecise)(highRateDebt.rate)}, senza alcun rischio: non esiste niente di meglio sul mercato. Tutto il margine mensile va qui, prima di ogni altra cosa.`,
        severity: 'critical'
    });
    if (metrics.emergencyGap > 0) warnings.push({
        title: 'Fondo emergenza incompleto',
        body: `Ti mancano ${(0, $bdDJG.euro)(metrics.emergencyGap)} per arrivare al cuscinetto consigliato di ${(0, $bdDJG.euro)(metrics.emergencyTarget)}. Senza questo paracadute, un imprevisto potrebbe costringerti a vendere investimenti nel momento sbagliato.`,
        severity: 'warning'
    });
    if (metrics.operationalLiquidityGap > 0) warnings.push({
        title: "Liquidit\xe0 del mese sotto il necessario",
        body: `Tolto il fondo emergenza che tieni sui conti, ti restano ${(0, $bdDJG.euro)(metrics.operationalLiquidityCurrent)} per il mese, contro i ${(0, $bdDJG.euro)(metrics.operationalLiquidityTarget)} che ti servirebbero. Il margine per gestire il mese \xe8 pi\xf9 stretto del dovuto.`,
        severity: 'warning'
    });
    if (metrics.operationalLiquidityExcess > 0) warnings.push({
        title: metrics.idleCash > 0 ? `${(0, $bdDJG.euro)(metrics.idleCash)} fermi a tasso zero` : "Pi\xf9 liquidit\xe0 del necessario, ma sta rendendo",
        body: metrics.idleCash > 0 ? `Oltre alla liquidit\xe0 che ti serve per il mese, ${(0, $bdDJG.euro)(metrics.idleCash)} non rendono niente: ${$5151854d1465ccaf$export$367739d89834ce60(metrics.idleSources)}. Sono i soldi che l'inflazione erode anno dopo anno.${metrics.bestCheckingRate > 0 ? ` Il tuo conto migliore (${metrics.bestCheckingLabel}) rende gi\xe0 il ${(0, $bdDJG.formatRate)(metrics.bestCheckingRate)}: anche solo spostarli l\xec \xe8 un guadagno.` : ' Un conto corrente remunerato o un conto deposito libero risolvono il problema senza toglierti accesso ai soldi.'}${metrics.workingExcess > 0 ? ` Il resto dell'eccedenza (${(0, $bdDJG.euro)(metrics.workingExcess)}) sta invece su conti che rendono: quello va bene dov'\xe8.` : ''}` : `Hai circa ${(0, $bdDJG.euro)(metrics.operationalLiquidityExcess)} oltre la liquidit\xe0 che ti serve per il mese, ma sono su conti che rendono: nessuna urgenza di spostarli. Manca solo assegnare loro un compito, cio\xe8 decidere se coprono una spesa prevista o se possono restare fermi a lungo.`,
        severity: metrics.idleCash > 0 ? 'warning' : 'info'
    });
    if (metrics.emergencyExcess > 0) warnings.push({
        title: 'Fondo emergenza sopra il target',
        body: `Hai ${(0, $bdDJG.euro)(metrics.emergencyExcess)} oltre il fondo emergenza consigliato. Non \xe8 un errore: \xe8 semplicemente sicurezza in pi\xf9 che non serve etichettare come intoccabile. Se sta su un conto che rende, va bene dov'\xe8; il punto \xe8 darle un compito, cio\xe8 decidere se copre una spesa prevista o se pu\xf2 restare ferma a lungo.`,
        severity: 'info'
    });
    if (riskyInvestments > 0 && metrics.emergencyGap > 0) warnings.push({
        title: 'Hai invertito l\'ordine: investimenti senza paracadute',
        body: `Hai ${(0, $bdDJG.euro)(riskyInvestments)} esposti a volatilit\xe0 ma il fondo emergenza non \xe8 completo. Il metodo qui non ammette eccezioni: se domani perdi il lavoro con i mercati in calo, vendi in perdita nel momento peggiore. Prima di aggiungere un solo euro agli investimenti, completa il fondo. E se oggi le posizioni sono in attivo, ridurle per accelerare la costruzione del fondo pu\xf2 essere la mossa pi\xf9 conveniente: si torna a investire dopo, con il paracadute al suo posto. La scelta resta tua.`,
        severity: 'critical'
    });
    if (metrics.uncoveredGoalsWithinTenYears.length > 0) warnings.push({
        title: 'Spese previste non completamente coperte',
        body: metrics.uncoveredGoalsWithinTenYears.length === 1 ? "Hai 1 spesa prevista entro 10 anni che oggi non risulta coperta interamente da conti deposito, obbligazioni o liquidit\xe0 eccedente. Prima di aumentare il rischio, chiudi questo gap." : `Hai ${metrics.uncoveredGoalsWithinTenYears.length} spese previste entro 10 anni che oggi non risultano coperte interamente da conti deposito, obbligazioni o liquidit\xe0 eccedente. Prima di aumentare il rischio, chiudi questi gap.`,
        severity: 'info'
    });
    const uncoveredShortGoals = metrics.goalCoverage.filter((goal)=>goal.years <= 1 && goal.gap > 0);
    if (riskyInvestments > 0 && uncoveredShortGoals.length > 0) warnings.push({
        title: 'Capitale rischioso con spese sotto 12 mesi',
        body: `Hai ${(0, $bdDJG.euro)(riskyInvestments)} in strumenti rischiosi mentre hai spese previste entro 12 mesi ancora scoperte per ${(0, $bdDJG.euro)(uncoveredShortGoals.reduce((sum, goal)=>sum + goal.gap, 0))}. Quei soldi non andrebbero trattati come lungo termine pienamente disponibile.`,
        severity: 'warning'
    });
    if (metrics.riskTolerance === 'low') warnings.push({
        title: 'Tolleranza al rischio bassa',
        body: "La tua reazione al calo o la frequenza di controllo rendono probabile una vendita nel momento peggiore. Considera strumenti pi\xf9 stabili come obbligazioni o conto deposito.",
        severity: 'info'
    });
    if ((0, $bdDJG.clampNumber)(data.accountFee) > 100) warnings.push({
        title: 'Conto corrente costoso',
        body: `Paghi circa ${(0, $bdDJG.euro)((0, $bdDJG.clampNumber)(data.accountFee))} all'anno. Vale la pena verificare alternative a costo zero: un canone da 120 euro equivale a dover investire 2400 euro al 5% per recuperare la stessa cifra.`,
        severity: 'info'
    });
    if ((0, $bdDJG.clampNumber)(data.accountFee) > 0 && (0, $bdDJG.clampNumber)(data.accountFee) <= 100) warnings.push({
        title: 'Canone conto non zero',
        body: "Paghi un canone annuo ma esistono conti correnti completamente gratuiti: cambiare \xe8 il risparmio pi\xf9 facile che c'\xe8, certo e senza rischio.",
        severity: 'info'
    });
    // 9 errors warnings - fondi comuni
    if (metrics.investments.funds > 0) warnings.push({
        title: 'Fondi comuni nel portafoglio',
        body: `Hai ${(0, $bdDJG.euro)(metrics.investments.funds)} in fondi comuni. I costi medi sono spesso superiori al 2% all'anno, molto pi\xf9 alti rispetto a un ETF equivalente (sotto lo 0,25%). Nel lungo periodo i costi elevati erodono una parte significativa del rendimento. Il confronto standard \xe8 con un ETF che replica lo stesso indice a costi molto pi\xf9 bassi: vale la pena chiedere al tuo intermediario il dettaglio dei costi che paghi oggi.`,
        severity: 'warning'
    });
    // 9 errors warnings - azioni singole
    const totalPortfolio = riskyInvestments + metrics.investments.bonds + metrics.investments.moneyMarket + metrics.investments.postalBonds + metrics.investments.lifeInsurance;
    if (metrics.investments.stocks > 0 && totalPortfolio < 10000) warnings.push({
        title: 'Azioni singole con portafoglio piccolo',
        body: `Hai ${(0, $bdDJG.euro)(metrics.investments.stocks)} in azioni singole con un portafoglio totale sotto i 10.000 euro. La concentrazione su poche aziende aumenta il rischio: se una azienda fallisce, perdi una quota rilevante del capitale. Con portafogli piccoli \xe8 ancora pi\xf9 importante diversificare tramite ETF.`,
        severity: 'warning'
    });
    // 9 errors warnings - crypto
    if (metrics.investments.crypto > 0) warnings.push({
        title: metrics.investments.bonds === 0 && metrics.investments.etf === 0 ? 'Crypto senza base: stai speculando, non investendo' : 'Criptovalute nel portafoglio',
        body: metrics.investments.bonds === 0 && metrics.investments.etf === 0 ? `Hai ${(0, $bdDJG.euro)(metrics.investments.crypto)} in criptovalute e nessuno strumento di base come obbligazioni o ETF diversificati. Chiamiamola col suo nome: \xe8 speculazione, non un piano di investimento. Va bene solo come quota che puoi permetterti di perdere per intero, e solo dopo aver sistemato fondo emergenza e spese previste.` : `Hai ${(0, $bdDJG.euro)(metrics.investments.crypto)} in criptovalute. La volatilit\xe0 estrema (oscillazioni del 50-80% in pochi mesi) le rende pi\xf9 vicine alla speculazione che all'investimento. Se non hai il fondo emergenza completo o hai obiettivi a breve termine, il rischio \xe8 amplificato. Trattale come quota marginale e consapevole del rischio, non come base del portafoglio.`,
        severity: 'warning'
    });
    // New warnings based on additional fields
    if (data.emergencyLocation === 'deposit_bound') warnings.push({
        title: 'Fondo emergenza vincolato',
        body: "Il tuo fondo emergenza \xe8 su un conto deposito vincolato: in caso di emergenza non potresti accedervi subito senza perdere gli interessi. Sposta il fondo su un conto deposito libero o svincolabile.",
        severity: 'critical'
    });
    if (data.emergencyLocation === 'checking' && (0, $bdDJG.clampNumber)(data.emergencyAmount) > 0) {
        const fund = (0, $bdDJG.clampNumber)(data.emergencyAmount);
        // Il fondo "sul conto corrente" rende solo per la parte che ci sta fisicamente sui conti remunerati
        const allAccounts = $5151854d1465ccaf$export$61c5c4f75131c04b(data);
        const remuneratedBalance = allAccounts.filter((account)=>account.interestRate > 0).reduce((sum, account)=>sum + account.balance, 0);
        const accountIndex = data.emergencyAccount !== '' && data.emergencyAccount !== undefined ? Number(data.emergencyAccount) : null;
        const chosenAccount = accountIndex !== null && Number.isInteger(accountIndex) ? allAccounts[accountIndex] : null;
        if (chosenAccount ? chosenAccount.interestRate <= 0 : remuneratedBalance <= 0) warnings.push({
            title: 'Fondo emergenza su conto non remunerato',
            body: `Tieni ${(0, $bdDJG.euro)(fund)} di fondo emergenza su ${chosenAccount ? chosenAccount.label || 'un conto' : 'un conto corrente'} che non rende interessi. L'accessibilit\xe0 va bene, ma cos\xec perde potere d'acquisto ogni anno: il conto corrente va bene solo se remunerato. In alternativa, spostalo su un conto deposito libero o svincolabile.`,
            severity: 'warning'
        });
        else if (!chosenAccount && allAccounts.length > 1) warnings.push({
            title: 'Fondo emergenza: controlla su quale conto sta',
            body: `Hai pi\xf9 conti correnti e il fondo potrebbe stare in parte su quelli non remunerati, dove non rende nulla e si svaluta piano piano. Sui tuoi conti remunerati ce ne pu\xf2 stare al massimo ${(0, $bdDJG.euro)(remuneratedBalance)}: verifica che il fondo stia l\xec, o sposta il resto su un deposito libero o svincolabile.`,
            severity: 'info'
        });
        else if (!chosenAccount && fund > remuneratedBalance) warnings.push({
            title: 'Parte del fondo emergenza non rende',
            body: `Dei ${(0, $bdDJG.euro)(fund)} di fondo emergenza, il conto remunerato oggi ne copre al massimo ${(0, $bdDJG.euro)(remuneratedBalance)}: almeno ${(0, $bdDJG.euro)(fund - remuneratedBalance)} stanno per forza a tasso zero, dove perdono potere d'acquisto. Sposta quella parte su un conto remunerato o su un deposito libero o svincolabile.`,
            severity: 'warning'
        });
    }
    // Fondo spezzato: conoscendo la composizione, i problemi si segnalano con le cifre esatte
    if (data.emergencyLocation === 'split' && metrics.emergencySplitDetail) {
        const zeroRatePart = metrics.emergencySplitDetail.filter((part)=>part.kind === 'account' && part.yields === false).reduce((sum, part)=>sum + part.amount, 0);
        if (zeroRatePart > 0) warnings.push({
            title: 'Parte del fondo emergenza non rende',
            body: `${(0, $bdDJG.euro)(zeroRatePart)} del fondo stanno su conti correnti che non rendono: quella parte ogni anno vale un po' meno. Spostala su un conto remunerato o su un deposito libero o svincolabile.`,
            severity: 'warning'
        });
        const boundPart = metrics.emergencySplitDetail.filter((part)=>part.kind === 'deposit' && !part.accessible).reduce((sum, part)=>sum + part.amount, 0);
        if (boundPart > 0) warnings.push({
            title: "Parte del fondo emergenza \xe8 vincolata",
            body: `${(0, $bdDJG.euro)(boundPart)} del fondo stanno su un deposito vincolato: in emergenza non li puoi toccare senza perdere gli interessi. Spostali su un deposito libero o svincolabile.`,
            severity: 'critical'
        });
    }
    {
        const boundDeposits = $5151854d1465ccaf$export$ff94d6ea7dbc5f35(data).filter((deposit)=>deposit.type === 'bound' && deposit.balance > 0);
        const boundNoMaturity = boundDeposits.filter((deposit)=>deposit.monthsToMaturity === null);
        if (boundNoMaturity.length > 0) warnings.push({
            title: boundNoMaturity.length === 1 ? `Vincolo senza scadenza dichiarata: ${boundNoMaturity[0].label || 'conto deposito'}` : 'Vincoli senza scadenza dichiarata',
            body: `Per ${boundNoMaturity.map((deposit)=>deposit.label || 'conto deposito').join(' e ')} non hai indicato quando si svincola: senza quella data non possiamo contare quei soldi per le spese previste. Aggiungila nel wizard e il piano diventa pi\xf9 preciso.`,
            severity: 'info'
        });
        else if (boundDeposits.length > 0) warnings.push({
            title: 'Hai depositi vincolati: occhio alle date',
            body: `${boundDeposits.map((deposit)=>`${deposit.label || 'conto deposito'} si svincola tra ${deposit.monthsToMaturity} mesi`).join('; ')}. Vanno bene solo per spese che arrivano dopo quelle date: svincolare in anticipo di solito costa gli interessi maturati.`,
            severity: 'info'
        });
    }
    // Tace se il warning sui soldi fermi ha già raccontato la stessa storia con cifre più precise
    const idleAlreadyWarned = metrics.operationalLiquidityExcess > 0 && metrics.idleCash > 0;
    if (!idleAlreadyWarned && $5151854d1465ccaf$var$getCheckingInterestProfile(data) === 'no' && $5151854d1465ccaf$export$bd64c3cff6c9a648(data) > 10000 && $5151854d1465ccaf$export$ff94d6ea7dbc5f35(data).length === 0) {
        const excessLiquidity = Math.max($5151854d1465ccaf$export$bd64c3cff6c9a648(data) - metrics.expenses * 3, 0);
        warnings.push({
            title: 'Soldi fermi su conti non remunerati',
            body: `Hai ${(0, $bdDJG.euro)($5151854d1465ccaf$export$bd64c3cff6c9a648(data))} su conti correnti che non rendono interessi. La parte oltre 3 mesi di spese (${(0, $bdDJG.euro)(excessLiquidity)}) potrebbe rendere qualcosa senza perdere accessibilit\xe0: va bene sia un conto corrente remunerato sia un conto deposito libero. Non serve cambiare banca: molte banche permettono di aprirli online in pochi minuti.`,
            severity: 'info'
        });
    }
    if (metrics.goalsWithinTenYears.length > 0 && metrics.uncoveredGoalsWithinTenYears.length === 0) warnings.push({
        title: "Spese previste gi\xe0 coperte",
        body: "Le spese previste entro 10 anni risultano gi\xe0 abbinate a patrimonio prudente esistente. Il nodo non \xe8 reperire capitale, ma tenerlo ben separato dal lungo termine.",
        severity: 'info'
    });
    // Credit card warnings
    if ((0, $bdDJG.clampNumber)(data.creditCardFee) > 50) warnings.push({
        title: 'Canone carta elevato',
        body: `Paghi ${(0, $bdDJG.euro)((0, $bdDJG.clampNumber)(data.creditCardFee))}/anno di canone per la carta. Esistono carte di credito senza canone o con cashback che compensa il costo. Valuta se i benefit della tua carta giustificano la spesa.`,
        severity: 'info'
    });
    if (data.hasCreditCard === 'prepaid') warnings.push({
        title: 'Carta prepagata: attenzione ai limiti',
        body: 'Le carte prepagate hanno costi di ricarica e limiti di utilizzo che le rendono meno convenienti rispetto a carte di debito o credito gratuite. Se usi la carta frequentemente, una carta di debito associata al conto corrente o una carta di credito senza canone potrebbe costarti meno nel complesso.',
        severity: 'info'
    });
    // Broker fee warning
    if ((0, $bdDJG.clampNumber)(data.brokerFee) > 50) warnings.push({
        title: 'Costi broker elevati',
        body: `Paghi ${(0, $bdDJG.euro)((0, $bdDJG.clampNumber)(data.brokerFee))}/anno per il conto titoli. Esistono broker con commissioni zero su ETF e PAC. I costi elevati erodono il rendimento nel lungo periodo, specialmente su importi mensili ridotti.`,
        severity: 'info'
    });
    if (metrics.investments.cash > 0 && metrics.emergencyGap > 0) warnings.push({
        title: "Liquidit\xe0 ferma sul broker",
        body: `Hai ${(0, $bdDJG.euro)(metrics.investments.cash)} non investiti sul conto titoli mentre il fondo emergenza \xe8 incompleto. Quella liquidit\xe0 pu\xf2 chiudere il gap subito: spostala dove \xe8 dedicata alla sicurezza e rende qualcosa.`,
        severity: 'info'
    });
    if (metrics.totalDepositBalance > 0 && data.emergencyStatus === 'none') warnings.push({
        title: 'Conto deposito ma nessun fondo emergenza',
        body: metrics.implicitEmergency ? "Hai soldi su un conto deposito ma nessuna quota etichettata come fondo emergenza. Nella sezione del fondo emergenza trovi la proposta gi\xe0 pronta: un click e aggiorniamo il check-up." : 'Hai soldi su un conto deposito ma non hai ancora etichettato una quota come fondo emergenza. Chiarire questa destinazione evita di confondere sicurezza, spese previste e lungo termine.',
        severity: 'info'
    });
    // La polizza di risparmio con le basi scoperte: l'incoerenza che il malus
    // in pagella misura, raccontata con le opzioni (senza spingere al riscatto).
    if (metrics.lifeInsurance.value > 0 && (metrics.emergencyGap > 0 || metrics.uncoveredGoalsWithinTenYears.length > 0)) {
        const holes = [
            metrics.emergencyGap > 0 ? `il fondo emergenza \xe8 scoperto per ${(0, $bdDJG.euro)(metrics.emergencyGap)}` : null,
            metrics.uncoveredGoalsWithinTenYears.length > 0 ? `${metrics.uncoveredGoalsWithinTenYears.length === 1 ? "una spesa prevista non \xe8 coperta" : 'delle spese previste non sono coperte'}` : null
        ].filter(Boolean).join(' e ');
        warnings.push({
            title: 'Risparmio in polizza mentre le basi sono scoperte',
            body: `Hai ${(0, $bdDJG.euro)(metrics.lifeInsurance.value)} in una polizza di risparmio, ma ${holes}. La polizza non \xe8 denaro pronto: il riscatto ha tempi, spesso penali nei primi anni e una fiscalit\xe0 sua. Non ti diciamo di riscattarla: chiedi per\xf2 il rendiconto e le condizioni di riscatto, e considera di sospendere eventuali versamenti ricorrenti finch\xe9 le basi non sono a posto. Ogni euro nuovo, prima al fondo emergenza.`,
            severity: 'warning'
        });
    }
    if (metrics.lifeInsurance.kind === 'unknown' && metrics.lifeInsurance.value > 0) warnings.push({
        title: "Polizza da identificare: il piano resta a met\xe0",
        body: `Hai ${(0, $bdDJG.euro)(metrics.lifeInsurance.value)} in una polizza di cui non conosci la natura: finch\xe9 non sai se il capitale \xe8 garantito o investe in fondi, quei soldi non possono coprire nessuna spesa nel piano. Chiedi il rendiconto annuale e il set informativo (KID): con quello in mano, rifai il check-up e il quadro si completa.`,
        severity: 'info'
    });
    return warnings;
}
function $5151854d1465ccaf$var$buildActionPlan(data, metrics) {
    const actions = [];
    const monthlyCapacity = Math.max(metrics.cashFlow, 0);
    const highRateDebt = metrics.debts.find((debt)=>debt.rate > 10);
    if (highRateDebt) actions.push({
        title: 'Abbatti i debiti costosi',
        body: `Concentra il margine su ${highRateDebt.label.toLowerCase()} finch\xe9 il tasso sopra il 10% non \xe8 eliminato o drasticamente ridotto. Estinguere un debito al ${(0, $bdDJG.percentPrecise)(highRateDebt.rate)} \xe8 equivalente a un investimento con rendimento garantito allo stesso tasso.`,
        meta: `Debito attuale: ${(0, $bdDJG.euro)(highRateDebt.amount)} \xb7 Tasso: ${(0, $bdDJG.percentPrecise)(highRateDebt.rate)}`
    });
    if (metrics.cashFlow < 0) actions.push({
        title: 'Riportare in positivo il cash flow',
        body: 'Riduci le spese fisse, rinegozia i costi ricorrenti o cerca di aumentare le entrate: senza margine il piano non regge.',
        meta: `Gap mensile: ${(0, $bdDJG.euro)(Math.abs(metrics.cashFlow))}`
    });
    if (metrics.emergencyGap > 0) {
        const monthsToFill = monthlyCapacity > 0 ? Math.ceil(metrics.emergencyGap / monthlyCapacity) : null;
        const suggestedLocation = data.emergencyLocation === 'checking' ? $5151854d1465ccaf$var$getCheckingInterestProfile(data) === 'yes_small' ? ' Il conto corrente remunerato va bene come base del fondo emergenza: i soldi restano disponibili e rendono qualcosa.' : " Il conto corrente non remunerato non \xe8 la casa giusta per il fondo: spostalo su un conto remunerato o su un deposito libero o svincolabile, cos\xec non perde valore nel tempo." : ' Usa solo strumenti subito disponibili e che rendono qualcosa: conto corrente remunerato separato, deposito libero o svincolabile. Evita il vincolo e gli investimenti rischiosi.';
        actions.push({
            title: 'Costruisci il fondo emergenza',
            body: `Porta il fondo a ${(0, $bdDJG.euro)(metrics.emergencyTarget)}.${suggestedLocation}`,
            meta: monthsToFill ? `Con ${(0, $bdDJG.euro)(monthlyCapacity)}/mese lo completi in circa ${monthsToFill} mesi.` : 'Serve creare margine mensile prima di poterlo completare.'
        });
    }
    if (data.emergencyLocation === 'deposit_bound') actions.push({
        title: 'Svincola il conto deposito per il fondo emergenza',
        body: "Il fondo emergenza deve essere subito accessibile. Sposta i soldi dal conto deposito vincolato a uno libero o svincolabile: perderai gli interessi maturati ma guadagnerai la flessibilit\xe0 che serve in caso di emergenza.",
        meta: 'Azione consigliata: contatta la tua banca per lo svincolo'
    });
    if (metrics.operationalLiquidityExcess > 0 && metrics.emergencyGap > 0) {
        const excessAmount = Math.min(metrics.operationalLiquidityExcess, metrics.emergencyGap);
        actions.push({
            title: "Sposta la liquidit\xe0 in eccesso",
            body: `Hai circa ${(0, $bdDJG.euro)(metrics.operationalLiquidityExcess)} oltre la liquidit\xe0 che serve per il mese. Se il fondo emergenza \xe8 incompleto, destina almeno ${(0, $bdDJG.euro)(excessAmount)} di questa quota al fondo emergenza o a una riserva separata.`,
            meta: `Liquidit\xe0 in eccesso: ${(0, $bdDJG.euro)(metrics.operationalLiquidityExcess)}`
        });
    }
    if (metrics.emergencyExcess > 0 || metrics.operationalLiquidityExcess > 0) {
        const reallocableAmount = metrics.emergencyExcess + metrics.operationalLiquidityExcess;
        const uncoveredNearGoals = metrics.goalCoverage.filter((goal)=>goal.years <= 10 && goal.gap > 0);
        if (uncoveredNearGoals.length > 0) {
            const nearestGoal = uncoveredNearGoals[0];
            const idle = metrics.idleCash;
            const working = metrics.workingExcess;
            const bestRate = metrics.bestCheckingRate;
            const locationNote = idle > 0 ? ` L'urgenza \xe8 una sola: ${(0, $bdDJG.euro)(idle)} sono fermi a tasso zero (${$5151854d1465ccaf$export$367739d89834ce60(metrics.idleSources)}), e l\xec perdono valore ogni anno.${working > 0 ? ` Gli altri ${(0, $bdDJG.euro)(working)} stanno gi\xe0 su conti che rendono${bestRate > 0 ? ` il ${(0, $bdDJG.formatRate)(bestRate)}` : ''}: quelli non hanno fretta di muoversi, gli manca solo un compito.` : ''}` : bestRate > 0 ? ` Non c'\xe8 urgenza: sono gi\xe0 su conti che rendono il ${(0, $bdDJG.formatRate)(bestRate)}, quindi non li sta mangiando l'inflazione. Serve solo dirgli a cosa servono.` : ' Oggi non rendono nulla: un conto remunerato o un deposito libero risolvono il problema senza toglierti l\'accesso ai soldi.';
            actions.push({
                title: idle > 0 ? 'Sveglia i soldi che dormono' : 'Dai un compito ai soldi in eccesso',
                body: `Hai ${(0, $bdDJG.euro)(reallocableAmount)} tra liquidit\xe0 in eccesso e fondo emergenza sopra target, e ${nearestGoal.label} \xe8 ancora scoperta per ${(0, $bdDJG.euro)(nearestGoal.gap)}.${locationNote}`,
                meta: `Per una spesa ${$5151854d1465ccaf$export$aca044a98be75fce(nearestGoal.years)}: ${$5151854d1465ccaf$export$94f35dad18a9751d(nearestGoal.recommendedInstrument)}`
            });
        } else if (metrics.longTermInvestingAllowed) actions.push({
            title: 'Rialloca le eccedenze sul lungo termine',
            body: `Coperti la liquidit\xe0 del mese, il fondo emergenza e le spese previste, ti restano ${(0, $bdDJG.euro)(reallocableAmount)} liberi. Questa quota pu\xf2 andare sul lungo termine.`,
            meta: 'Destinazione coerente: portafoglio di lungo termine'
        });
        else actions.push({
            title: 'Tieni le eccedenze in riserva prudente separata',
            body: `Hai ${(0, $bdDJG.euro)(reallocableAmount)} riallocabili, ma non hai ancora i prerequisiti per spostarli sul lungo termine. Tienili separati su strumenti prudenti finch\xe9 non chiudi i blocchi principali.`,
            meta: `Blocco attuale: ${metrics.longTermBlockReason}`
        });
    }
    const uncoveredShortGoals = metrics.goalCoverage.filter((goal)=>goal.years <= 1 && goal.gap > 0);
    if (metrics.riskyInvestmentsValue > 0 && uncoveredShortGoals.length > 0) {
        const shortGap = uncoveredShortGoals.reduce((sum, goal)=>sum + goal.gap, 0);
        const suggestedReallocation = Math.min(metrics.riskyInvestmentsValue, shortGap);
        actions.push({
            title: 'Valuta la riallocazione degli investimenti rischiosi',
            body: `Hai ${(0, $bdDJG.euro)(metrics.riskyInvestmentsValue)} in ETF, azioni, fondi o crypto mentre restano ${(0, $bdDJG.euro)(shortGap)} di spese da coprire entro 12 mesi. Se quei soldi possono servirti davvero per questi obiettivi, non dovrebbero restare in strumenti volatili.`,
            meta: `Riallocazione potenziale da valutare: fino a ${(0, $bdDJG.euro)(suggestedReallocation)} verso strumenti a brevissimo termine`
        });
    }
    metrics.goalCoverage.forEach((goal)=>{
        const monthlyNeed = goal.gap / Math.max(goal.years * 12, 1);
        actions.push({
            title: `Pianifica: ${goal.label}`,
            body: goal.fullyCovered ? `${goal.label} ${$5151854d1465ccaf$export$aca044a98be75fce(goal.years)} risulta gi\xe0 coperto con i soldi sicuri che hai. Mantieni questa quota separata dal capitale di lungo termine e non spostarla su strumenti pi\xf9 rischiosi.` : `Per ${goal.label} ${$5151854d1465ccaf$export$aca044a98be75fce(goal.years)} oggi hai gi\xe0 coperto ${(0, $bdDJG.euro)(goal.coveredAmount)}. Restano da destinare ${(0, $bdDJG.euro)(goal.gap)}: ${$5151854d1465ccaf$export$94f35dad18a9751d(goal.recommendedInstrument)}.`,
            meta: goal.fullyCovered ? `Gi\xe0 coperto: ${(0, $bdDJG.euro)(goal.coveredAmount)}` : `Gap residuo: ${(0, $bdDJG.euro)(goal.gap)} \xb7 Accumulo indicativo: ${(0, $bdDJG.euro)(monthlyNeed)}/mese`
        });
    });
    const annualBankingCosts = (0, $bdDJG.clampNumber)(data.accountFee) + (0, $bdDJG.clampNumber)(data.creditCardFee) + (0, $bdDJG.clampNumber)(data.brokerFee);
    if (annualBankingCosts > 100) actions.push({
        title: 'Riduci i costi bancari',
        body: `I tuoi costi annuali di banking sono ${(0, $bdDJG.euro)(annualBankingCosts)}. Ogni 100 euro eliminati all\'anno equivalgono a ${(0, $bdDJG.euro)(2000)} investiti al 5%: \xe8 risparmio garantito. Verifica conti correnti a costo zero, carte senza canone (o con cashback che lo compensi) e broker con commissioni competitive.`,
        meta: `Costi attuali: ${(0, $bdDJG.euro)(annualBankingCosts)}/anno \xb7 Potenziale risparmio: ${(0, $bdDJG.euro)(Math.max(0, annualBankingCosts - 50))}`
    });
    actions.push({
        title: metrics.longTermInvestingAllowed ? 'Lungo termine: le basi ci sono' : 'Lungo termine: non ancora',
        body: metrics.longTermInvestingAllowed ? "I prerequisiti di base sono a posto: sicurezza, debiti e spese previste non ti bloccano pi\xf9. Da qui in avanti si parla solo del capitale che non ti serve per almeno dieci anni, e le due cose che pesano di pi\xf9 sul risultato sono la diversificazione e i costi. Quanto destinarci e con quali strumenti resta una decisione tua, eventualmente con un consulente autorizzato." : "Prima del lungo termine vengono sicurezza, debiti costosi e copertura delle spese che hanno gi\xe0 una data.",
        meta: metrics.longTermInvestingAllowed ? 'Nessun blocco residuo sui prerequisiti di base' : `Blocco principale: ${metrics.longTermBlockReason}`
    });
    return actions;
}
function $5151854d1465ccaf$var$buildInstrumentCards(data, metrics) {
    const cards = [
        {
            icon: 'bank',
            title: 'Conto corrente',
            body: "Per le spese quotidiane e la liquidit\xe0 del mese, non per tenere tutte le riserve nello stesso contenitore.",
            detail: "<p>Il conto corrente serve per la gestione quotidiana e per una quota operativa di breve periodo. Se il tuo fondo emergenza \xe8 qui e il conto rende, pu\xf2 andare bene: l'importante \xe8 che quella somma sia riconoscibile e non venga confusa con soldi disponibili da spendere.</p><p><strong>Cosa controllare:</strong> canone annuo (meglio se zero), costi bonifici, carte associate. Se paghi pi\xf9 di 100 euro all'anno di canone, valuta alternative.</p><p><strong>Fiscalit\xe0:</strong> gli interessi su conti correnti remunerati sono tassati al 26%. Se il saldo supera i 5.000 euro, si applica l'imposta di bollo annua di 34,20 euro.</p>"
        },
        {
            icon: 'piggy-bank',
            title: 'Conto deposito',
            body: metrics.deposits.length > 0 ? `Hai ${metrics.deposits.length === 1 ? 'un conto deposito' : `${metrics.deposits.length} conti deposito`} per ${(0, $bdDJG.euro)(metrics.totalDepositBalance)} in totale. Sono una riserva separata utile per fondo emergenza e spese previste, da non confondere con la liquidit\xe0 di tutti i giorni.` : 'Utile come riserva separata per fondo emergenza e spese previste di breve/medio termine.',
            detail: "<p>Il conto deposito \xe8 una riserva prudente: non \xe8 la liquidit\xe0 di tutti i giorni, ma capitale separato per il fondo emergenza o per spese previste. Rende sugli interessi ed \xe8 garantito dal Fondo Interbancario fino a 100.000 euro per depositante e banca.</p><p><strong>Libero o svincolabile:</strong> adatto quando vuoi accesso rapido. <strong>Vincolato:</strong> pu\xf2 andare per obiettivi con data certa, ma non per emergenze immediate.</p><p><strong>Fiscalit\xe0:</strong> tassazione del 26% sugli interessi. Imposta di bollo proporzionale dello 0,20% annuo sul saldo (a differenza del conto corrente, dove il bollo \xe8 fisso a 34,20 euro sopra i 5.000 di giacenza media). Alcune banche se ne fanno carico: controlla il foglio informativo.</p>"
        }
    ];
    if (metrics.goalsWithinTenYears.some((goal)=>goal.years <= 1)) cards.push({
        icon: 'hourglass',
        title: 'BOT',
        body: 'Per spese prevedibili entro 12 mesi o poco oltre.',
        detail: "<p>I Buoni Ordinari del Tesoro sono titoli di stato con durata fino a 12 mesi. Funzionano cos\xec: compri a un prezzo leggermente inferiore a 100 e lo stato ti rimborsa 100 alla scadenza. La differenza \xe8 il tuo guadagno.</p><p><strong>Fiscalit\xe0:</strong> 12,5% sugli interessi, agevolata rispetto al 26% dei depositi. Sul deposito titoli si applica il bollo dello 0,20% annuo sul controvalore.</p><p><strong>Rischio:</strong> basso su scadenze cos\xec brevi: paga lo stato italiano.</p>"
    });
    if (metrics.goalsWithinTenYears.some((goal)=>goal.years <= 3) || metrics.investments.moneyMarket > 0) cards.push({
        icon: 'coin-vertical',
        title: 'ETF monetari',
        body: metrics.investments.moneyMarket > 0 ? `Hai ${(0, $bdDJG.euro)(metrics.investments.moneyMarket)} in ETF monetari: nel piano contano come parcheggio remunerato, non come lungo termine.` : 'Il parcheggio remunerato senza scadenze, per riserve e spese entro un paio d\'anni.',
        detail: "<p>Un ETF monetario (XEON \xe8 il pi\xf9 noto) investe in strumenti a brevissimo termine e segue i tassi di interesse a breve dell'area euro. Il prezzo oscilla pochissimo e non ci sono scadenze: compri e vendi in borsa quando vuoi.</p><p><strong>Quando ha senso:</strong> riserve per spese previste entro un paio d'anni, in alternativa a conto deposito e BOT, specie se i soldi stanno gi\xe0 sul broker.</p><p><strong>Fiscalit\xe0:</strong> l'aliquota standard degli ETF \xe8 il 26%, ma la parte di rendimento riconducibile a titoli di Stato \xe8 tassata al 12,5%: per i monetari con paniere prevalentemente governativo l'aliquota effettiva \xe8 spesso intorno al 13-14% (il dato esatto sta nella documentazione fiscale dell'emittente). Si aggiunge il bollo dello 0,20% annuo sul controvalore.</p><p><strong>Rischio:</strong> molto basso, ma non \xe8 un conto: serve un conto titoli e i soldi arrivano un paio di giorni dopo la vendita.</p>"
    });
    if (metrics.goalsWithinTenYears.some((goal)=>goal.years > 1 && goal.years <= 10) || metrics.investments.bonds > 0) cards.push({
        icon: 'calendar-check',
        title: 'BTP',
        body: metrics.investments.bonds > 0 ? `Hai ${(0, $bdDJG.euro)(metrics.investments.bonds)} in obbligazioni: ecco come leggerle. Adatti a obiettivi da 2 a 10 anni con scadenza allineata alla spesa.` : 'Per obiettivi da 2 a 10 anni con scadenza allineata alla spesa.',
        detail: "<p>I Buoni del Tesoro Poliennali pagano una cedola ogni 6 mesi e rimborsano 100 euro alla scadenza. Il prezzo oscilla nel frattempo, ma se tieni fino alla scadenza questa oscillazione non ti riguarda.</p><p><strong>Strategia:</strong> l'abbinamento tipico \xe8 un BTP che scade vicino alla data in cui servono i soldi. Ti serve l'auto tra 4 anni? Si guardano i BTP che scadono intorno al 2030.</p><p><strong>Fiscalit\xe0:</strong> 12,5% su cedole e plusvalenze. Imposta di bollo dello 0,20% annuo sul capitale.</p>"
    });
    if (metrics.investments.postalBonds > 0) cards.push({
        icon: 'envelope-simple',
        title: 'Buoni fruttiferi postali',
        body: `Hai ${(0, $bdDJG.euro)(metrics.investments.postalBonds)} in buoni postali: nel piano contano come capitale prudente, buono per le spese con una data.`,
        detail: "<p>I buoni fruttiferi postali sono emessi da Cassa Depositi e Prestiti e garantiti dallo Stato. Si possono rimborsare in qualsiasi momento recuperando almeno il capitale versato: per questo nel check-up coprono le spese previste, come i titoli di Stato.</p><p><strong>Il punto a cui fare attenzione:</strong> il rendimento cresce a gradini con gli anni di possesso, e ogni serie fa storia a s\xe9. Le serie sottoscritte anni fa possono rendere bene; quelle recenti spesso rendono meno di un conto deposito o di un BTP di pari durata. Il rendimento effettivo a scadenza della tua serie sta nel foglio informativo.</p><p><strong>Fiscalit\xe0:</strong> 12,5% sugli interessi come i titoli di Stato, e niente imposta di bollo se il valore di rimborso complessivo non supera i 5.000 euro. Non ci sono costi di sottoscrizione n\xe9 di rimborso.</p>"
    });
    if (metrics.lifeInsurance.value > 0) {
        const kindNote = {
            guaranteed: 'A capitale garantito (gestione separata): nel piano conta come capitale prudente, utilizzabile per spese oltre i 3 anni, per ultima.',
            unit_linked: 'Unit-linked: investe in fondi tramite la polizza, oscilla coi mercati e nel piano conta come lungo termine.',
            unknown: "Di tipo ancora da verificare: finch\xe9 non sai cosa hai firmato, nel piano non copre nessuna spesa."
        }[metrics.lifeInsurance.kind];
        cards.push({
            icon: 'file-text',
            title: 'Polizza vita di risparmio',
            body: `Hai ${(0, $bdDJG.euro)(metrics.lifeInsurance.value)} in una polizza di risparmio. ${kindNote}`,
            detail: "<p>Le polizze vita di risparmio sono contenitori assicurativi attorno a un investimento. Le <strong>ramo I</strong> (gestione separata) proteggono il capitale e rendono poco; le <strong>unit-linked</strong> (ramo III) investono in fondi e oscillano coi mercati, spesso con costi pi\xf9 alti di un ETF equivalente.</p><p><strong>La domanda che conta \xe8 una sola: quanto costa?</strong> Caricamenti sui versamenti, commissione di gestione annua e eventuali penali di riscatto stanno nel set informativo (KID) e nel rendiconto annuale. Un costo ricorrente sopra il 2% all'anno erode gran parte del rendimento, comunque vadano i mercati.</p><p><strong>Cosa hanno di buono:</strong> il capitale liquidato ai beneficiari caso morte \xe8 esente da imposta di successione e fuori dall'asse ereditario, e i rendimenti delle gestioni separate si consolidano anno per anno. Sono vantaggi reali: vanno solo pesati contro i costi.</p><p><strong>Prima di ogni decisione:</strong> chiedi il rendiconto, verifica le condizioni di riscatto e confronta. Riscattare in anticipo pu\xf2 costare: la scelta va fatta coi numeri del tuo contratto davanti, eventualmente con un consulente indipendente.</p>"
        });
    }
    if (metrics.longTermInvestingAllowed) cards.push({
        icon: 'globe-hemisphere-west',
        title: 'ETF azionari globali',
        body: "La categoria di cui si parla quando il capitale \xe8 davvero di lungo termine e si tollera la volatilit\xe0.",
        detail: "<p>Un ETF \xe8 un \"paniere\" di azioni che replica un indice. Un indice mondiale rappresenta oltre mille aziende in decine di paesi: chi lo segue distribuisce il rischio invece di concentrarlo su pochi nomi o su un solo settore.</p><p><strong>I criteri di cui si discute di solito:</strong> quanto \xe8 ampio l'indice (i pi\xf9 citati sono MSCI World e FTSE All-World), quanto costa la gestione ogni anno (il TER: sotto lo 0,25% \xe8 considerato basso), e se i dividendi vengono reinvestiti automaticamente (accumulo) o versati sul conto (distribuzione).</p><p><strong>Il punto che conta davvero:</strong> il prezzo pu\xf2 scendere del 30-50% in un anno. Per questo si parla di orizzonte minimo di dieci anni e della capacit\xe0 di non vendere durante i ribassi. La parte difficile \xe8 questa, non la scelta dello strumento.</p><p><strong>Fiscalit\xe0:</strong> 26% su plusvalenze e dividendi, pi\xf9 l'imposta di bollo dello 0,20% annuo sul controvalore. I costi di gestione si sommano a questi: su trent'anni, un punto percentuale in pi\xf9 all'anno si mangia una fetta enorme del risultato.</p>"
    });
    // Emergency fund comparison table
    const fund = (0, $bdDJG.clampNumber)(data.emergencyAmount);
    if (fund >= 1000) {
        const bolloConto = fund > $5151854d1465ccaf$var$STAMP_DUTY_ACCOUNT_THRESHOLD ? $5151854d1465ccaf$var$STAMP_DUTY_ACCOUNT : 0;
        const bolloProporzionale = fund * $5151854d1465ccaf$var$STAMP_DUTY_PRODUCTS_RATE;
        const checkingNet = 0;
        const remuneratedGross = fund * 0.03;
        const remuneratedNet = Math.round(remuneratedGross * 0.74 - bolloConto);
        const depositGross = fund * 0.035;
        const depositNet = Math.round(depositGross * 0.74 - bolloProporzionale);
        const botGross = fund * 0.03;
        const botNet = Math.round(botGross * 0.875 - bolloProporzionale);
        cards.push({
            icon: 'scales',
            title: 'Confronto strumenti per il fondo emergenza',
            body: `Con un fondo di ${(0, $bdDJG.euro)(fund)}, quanto renderebbe all'anno in strumenti diversi (tassi indicativi, al netto di tasse e bollo).`,
            detail: `${(0, $bdDJG.comparisonTable)([
                {
                    header: 'Strumento'
                },
                {
                    header: 'Rendimento netto/anno',
                    wide: true
                },
                {
                    header: 'Note',
                    wide: true
                }
            ], [
                [
                    'Conto corrente (non remunerato)',
                    (0, $bdDJG.euro)(checkingNet),
                    `Subito accessibile${bolloConto > 0 ? ', bollo ' + (0, $bdDJG.euro)(bolloConto) + ' comunque dovuto' : ''}`
                ],
                [
                    'Conto corrente remunerato (3% lordo)',
                    `~${(0, $bdDJG.euro)(remuneratedNet)}`,
                    `Subito accessibile, 26% tasse${bolloConto > 0 ? ', bollo ' + (0, $bdDJG.euro)(bolloConto) : ''}`
                ],
                [
                    'Conto deposito libero (3,5% lordo)',
                    `~${(0, $bdDJG.euro)(depositNet)}`,
                    `Accesso immediato, 26% tasse, bollo 0,20% (${(0, $bdDJG.euro)(Math.round(bolloProporzionale))})`
                ],
                [
                    'BOT 12 mesi (3% lordo)',
                    `~${(0, $bdDJG.euro)(botNet)}`,
                    'Tassazione agevolata 12,5%, bollo 0,20%, scadenza fissa'
                ]
            ])}
      <p><strong>Importante:</strong> il fondo emergenza deve essere subito accessibile. Un conto corrente remunerato, se i soldi restano distinti dalla spesa quotidiana, \xe8 una collocazione perfettamente valida. Un conto deposito libero pu\xf2 rendere leggermente di pi\xf9 senza rinunciare all'accessibilit\xe0. Il vincolato no: in emergenza non aspetti la scadenza.</p>`,
            isComparison: true
        });
    }
    return cards;
}
function $5151854d1465ccaf$export$937499e792d12a74(rawData) {
    const data = {
        ...rawData,
        goals: $5151854d1465ccaf$export$c2e6bd574c9b8a58(rawData.goals || [])
    };
    const expenses = $5151854d1465ccaf$export$6067b10612da41ca(data);
    const essentialExpenses = $5151854d1465ccaf$export$96eccfdeca59400c(data);
    const discretionaryExpenses = $5151854d1465ccaf$var$getDiscretionaryExpenses(data);
    const cashFlow = $5151854d1465ccaf$export$25b9e0512b598c0f(data);
    const savingsRate = $5151854d1465ccaf$export$376c925e3f90f893(data);
    const liquidityMonths = $5151854d1465ccaf$var$getLiquidityMonths(data);
    const emergencyTarget = $5151854d1465ccaf$export$30c7e118c8f4b23c(data);
    const emergencyFloorApplied = $5151854d1465ccaf$export$6067b10612da41ca(data) * $5151854d1465ccaf$export$536a7ec2271cf81b(data) < $5151854d1465ccaf$export$c25d886fb123d323;
    const emergencyCurrent = (0, $bdDJG.clampNumber)(data.emergencyAmount);
    const emergencyGap = Math.max(emergencyTarget - emergencyCurrent, 0);
    const investments = $5151854d1465ccaf$var$getInvestments(data);
    const lifeInsurance = $5151854d1465ccaf$var$getLifeInsurance(data);
    const deposits = $5151854d1465ccaf$export$ff94d6ea7dbc5f35(data);
    const totalDepositBalance = $5151854d1465ccaf$export$2a7b52bce05aca00(data);
    const riskyInvestmentsValue = investments.stocks + investments.etf + investments.funds + investments.crypto;
    const debts = $5151854d1465ccaf$var$getDebts(data);
    const totalDebt = debts.reduce((sum, debt)=>sum + debt.amount, 0);
    const riskTolerance = $5151854d1465ccaf$var$getRiskTolerance(data);
    const goalsWithinTenYears = data.goals.filter((goal)=>goal.years <= 10);
    const operationalLiquidityTarget = $5151854d1465ccaf$export$d80ea2da88b88d0c(data);
    const totalCheckingBalance = $5151854d1465ccaf$export$bd64c3cff6c9a648(data);
    const reservedEmergencyAmount = Math.min(emergencyCurrent, emergencyTarget);
    // Fondo "spezzato in più posti": lo attribuiamo prima ai depositi (la casa classica
    // del fondo) e il resto ai conti correnti
    const isSplitEmergency = data.emergencyLocation === 'split';
    const isDepositEmergency = data.emergencyLocation === 'deposit_free' || data.emergencyLocation === 'deposit_withdrawable' || data.emergencyLocation === 'deposit_bound';
    // Se conosciamo la composizione (quanto su ciascun posto), l'allocazione è esatta;
    // altrimenti per lo split si usa l'euristica depositi-prima
    const emergencySplitDetail = isSplitEmergency ? $5151854d1465ccaf$var$buildEmergencySplitDetail(data) : null;
    const splitDepositAmount = emergencySplitDetail ? emergencySplitDetail.filter((part)=>part.kind === 'deposit').reduce((sum, part)=>sum + part.amount, 0) : null;
    const splitCheckingAmount = emergencySplitDetail ? emergencySplitDetail.filter((part)=>part.kind === 'account').reduce((sum, part)=>sum + part.amount, 0) : null;
    const emergencyAllocatedFromDeposit = isDepositEmergency ? Math.min(totalDepositBalance, emergencyCurrent) : isSplitEmergency ? Math.min(emergencySplitDetail ? splitDepositAmount : emergencyCurrent, totalDepositBalance) : 0;
    const emergencyAllocatedFromChecking = data.emergencyLocation === 'checking' ? Math.min(totalCheckingBalance, emergencyCurrent) : isSplitEmergency ? Math.min(totalCheckingBalance, emergencySplitDetail ? splitCheckingAmount : Math.max(emergencyCurrent - emergencyAllocatedFromDeposit, 0)) : 0;
    const emergencyReallocableFromChecking = Math.max(emergencyAllocatedFromChecking - reservedEmergencyAmount, 0);
    const emergencyReallocableFromDeposit = Math.max(emergencyAllocatedFromDeposit - reservedEmergencyAmount, 0);
    const operationalLiquidityCurrent = Math.max(totalCheckingBalance - emergencyAllocatedFromChecking, 0);
    const operationalLiquidityMonthsCovered = expenses > 0 ? operationalLiquidityCurrent / expenses : null;
    const operationalLiquidityGap = Math.max(operationalLiquidityTarget - operationalLiquidityCurrent, 0);
    const operationalLiquidityExcess = Math.max(operationalLiquidityCurrent - operationalLiquidityTarget, 0);
    const emergencyExcess = Math.max(emergencyCurrent - emergencyTarget, 0);
    // La quota di fondo emergenza tenuta sui depositi occupa prima i più accessibili;
    // il resto di ogni deposito resta disponibile per le spese previste.
    const emergencyOnDeposits = isDepositEmergency ? reservedEmergencyAmount : isSplitEmergency ? Math.min(reservedEmergencyAmount, emergencyAllocatedFromDeposit) : 0;
    let emergencyLeftToPlace = Math.min(emergencyOnDeposits, totalDepositBalance);
    const depositAvailability = deposits.slice().sort((a, b)=>$5151854d1465ccaf$var$DEPOSIT_ACCESS_ORDER[a.type] - $5151854d1465ccaf$var$DEPOSIT_ACCESS_ORDER[b.type]).map((deposit)=>{
        const held = Math.min(deposit.balance, emergencyLeftToPlace);
        emergencyLeftToPlace -= held;
        return {
            ...deposit,
            remaining: deposit.balance - held
        };
    });
    const goalCoverage = $5151854d1465ccaf$var$buildGoalCoverage(data.goals, {
        checking: operationalLiquidityExcess + emergencyReallocableFromChecking,
        deposits: depositAvailability,
        brokerCash: investments.cash,
        moneyMarket: investments.moneyMarket,
        bonds: investments.bonds,
        postalBonds: investments.postalBonds,
        lifeGuaranteed: lifeInsurance.prudent
    });
    const uncoveredGoalsWithinTenYears = goalCoverage.filter((goal)=>goal.years <= 10 && goal.gap > 0);
    const longTermBlockReason = debts.some((debt)=>debt.rate > 10) ? 'Debiti con tassi alti' : emergencyGap > 0 ? 'Fondo emergenza incompleto' : uncoveredGoalsWithinTenYears.length > 0 ? 'Spese previste da finanziare entro 10 anni' : riskTolerance === 'low' ? 'Tolleranza al rischio insufficiente' : cashFlow <= 0 ? 'Margine mensile insufficiente' : 'Nessuno';
    const longTermInvestingAllowed = longTermBlockReason === 'Nessuno';
    const marginalTaxRate = $5151854d1465ccaf$var$getMarginalTaxRate(data.ral);
    // Distinzione centrale: i soldi che rendono stanno bene dove sono, quelli fermi si svalutano.
    // La liquidità del mese si considera parcheggiata sui conti remunerati, se bastano:
    // così quello che sta su un conto a tasso zero risulta fermo per intero.
    const checkingAccountsList = $5151854d1465ccaf$export$61c5c4f75131c04b(data);
    const bestCheckingRate = checkingAccountsList.length ? Math.max(0, ...checkingAccountsList.map((a)=>a.interestRate)) : 0;
    const bestCheckingAccount = checkingAccountsList.find((account)=>account.interestRate === bestCheckingRate && bestCheckingRate > 0) || null;
    const brokerIdleCash = investments.cashRate > 0 ? 0 : investments.cash;
    // La quota di fondo emergenza dichiarata su ciascun conto non è liquidità: si scorpora
    const emergencyEarmarks = checkingAccountsList.map(()=>0);
    if (data.emergencyLocation === 'checking' && checkingAccountsList.length) {
        const declared = Number(data.emergencyAccount);
        if (Number.isInteger(declared) && checkingAccountsList[declared]) emergencyEarmarks[declared] = Math.min(emergencyAllocatedFromChecking, checkingAccountsList[declared].balance);
    } else if (isSplitEmergency && data.emergencySplit && data.emergencySplit.accounts) Object.entries(data.emergencySplit.accounts).forEach(([key, value])=>{
        const index = Number(key);
        if (checkingAccountsList[index]) emergencyEarmarks[index] = Math.min((0, $bdDJG.clampNumber)(value), checkingAccountsList[index].balance);
    });
    // Fondo sui conti senza un conto dichiarato (payload storici): si scala prima dai
    // conti a tasso zero, così gli stessi euro non risultano due volte "da sistemare"
    let unassignedEmergency = Math.max(emergencyAllocatedFromChecking - emergencyEarmarks.reduce((sum, value)=>sum + value, 0), 0);
    checkingAccountsList.map((account, index)=>({
            account: account,
            index: index
        })).sort((a, b)=>Number(a.account.interestRate > 0) - Number(b.account.interestRate > 0)).forEach(({ account: account, index: index })=>{
        if (unassignedEmergency <= 0) return;
        const room = Math.max(account.balance - emergencyEarmarks[index], 0);
        const taken = Math.min(room, unassignedEmergency);
        emergencyEarmarks[index] += taken;
        unassignedEmergency -= taken;
    });
    const freeBalances = checkingAccountsList.map((account, index)=>Math.max(account.balance - emergencyEarmarks[index], 0));
    const remuneratedFree = checkingAccountsList.reduce((sum, account, index)=>sum + (account.interestRate > 0 ? freeBalances[index] : 0), 0);
    // La parte di liquidità del mese che i conti remunerati non coprono può
    // legittimamente stare a tasso zero: solo il resto è fermo davvero
    let monthAtZeroRate = Math.max(operationalLiquidityTarget - remuneratedFree, 0);
    const idleSources = [];
    checkingAccountsList.forEach((account, index)=>{
        if (account.interestRate > 0) return;
        let free = freeBalances[index];
        const absorbed = Math.min(free, monthAtZeroRate);
        monthAtZeroRate -= absorbed;
        free -= absorbed;
        if (free > 0) idleSources.push({
            label: account.label || 'conto corrente',
            amount: free,
            broker: false
        });
    });
    if (brokerIdleCash > 0) idleSources.push({
        label: 'il cash sul broker',
        amount: brokerIdleCash,
        broker: true
    });
    const idleFromChecking = idleSources.filter((source)=>!source.broker).reduce((sum, source)=>sum + source.amount, 0);
    const idleCash = idleFromChecking + brokerIdleCash;
    const totalReallocable = operationalLiquidityExcess + emergencyExcess;
    // Il cash sul broker non fa parte dell'eccedenza dei conti: non si sottrae
    const workingExcess = Math.max(totalReallocable - idleFromChecking, 0);
    // Fondo emergenza implicito: chi dice di non averlo ma ha risparmi subito disponibili
    // ce l'ha già, solo che non lo chiama così. Contano solo i soldi accessibili subito:
    // depositi liberi/svincolabili e la liquidità sui conti oltre quella che serve per il mese.
    let implicitEmergency = null;
    if (data.emergencyStatus === 'none') {
        const accessibleDeposits = deposits.filter((deposit)=>deposit.type === 'free' || deposit.type === 'withdrawable');
        const accessibleDepositBalance = accessibleDeposits.reduce((sum, deposit)=>sum + deposit.balance, 0);
        const implicitAvailable = accessibleDepositBalance + operationalLiquidityExcess;
        const implicitAmount = Math.min(implicitAvailable, emergencyTarget);
        if (implicitAmount >= $5151854d1465ccaf$export$c25d886fb123d323) {
            const fromDeposits = Math.min(accessibleDepositBalance, implicitAmount);
            const location = fromDeposits >= implicitAmount / 2 ? accessibleDeposits.some((deposit)=>deposit.type === 'free' && deposit.balance > 0) ? 'deposit_free' : 'deposit_withdrawable' : 'checking';
            implicitEmergency = {
                amount: implicitAmount,
                available: implicitAvailable,
                fromDeposits: fromDeposits,
                fromChecking: Math.max(implicitAmount - fromDeposits, 0),
                location: location,
                onYield: location === 'checking' ? bestCheckingRate > 0 : true,
                coversTarget: implicitAmount >= emergencyTarget
            };
        }
    }
    const metrics = {
        expenses: expenses,
        essentialExpenses: essentialExpenses,
        discretionaryExpenses: discretionaryExpenses,
        cashFlow: cashFlow,
        savingsRate: savingsRate,
        liquidityMonths: liquidityMonths,
        operationalLiquidityMonthsCovered: operationalLiquidityMonthsCovered,
        operationalLiquidityTarget: operationalLiquidityTarget,
        operationalLiquidityCurrent: operationalLiquidityCurrent,
        operationalLiquidityGap: operationalLiquidityGap,
        operationalLiquidityExcess: operationalLiquidityExcess,
        emergencyTarget: emergencyTarget,
        emergencyFloorApplied: emergencyFloorApplied,
        emergencyCurrent: emergencyCurrent,
        emergencyGap: emergencyGap,
        emergencyExcess: emergencyExcess,
        reservedEmergencyAmount: reservedEmergencyAmount,
        emergencyAllocatedFromChecking: emergencyAllocatedFromChecking,
        emergencyAllocatedFromDeposit: emergencyAllocatedFromDeposit,
        investments: investments,
        lifeInsurance: lifeInsurance,
        totalDepositBalance: totalDepositBalance,
        riskyInvestmentsValue: riskyInvestmentsValue,
        debts: debts,
        totalDebt: totalDebt,
        riskTolerance: riskTolerance,
        idleCash: idleCash,
        idleSources: idleSources,
        workingExcess: workingExcess,
        bestCheckingRate: bestCheckingRate,
        bestCheckingLabel: bestCheckingAccount ? bestCheckingAccount.label : null,
        goalsWithinTenYears: goalsWithinTenYears,
        uncoveredGoalsWithinTenYears: uncoveredGoalsWithinTenYears,
        goalCoverage: goalCoverage,
        longTermInvestingAllowed: longTermInvestingAllowed,
        longTermBlockReason: longTermBlockReason,
        deposits: deposits,
        mainDepositType: $5151854d1465ccaf$var$getMainDepositType(deposits),
        accounts: $5151854d1465ccaf$export$61c5c4f75131c04b(data),
        checkingBalance: totalCheckingBalance,
        checkingInterest: $5151854d1465ccaf$var$getCheckingInterestProfile(data),
        emergencyLocation: data.emergencyLocation,
        emergencySplitDetail: emergencySplitDetail,
        implicitEmergency: implicitEmergency,
        marginalTaxRate: marginalTaxRate
    };
    return {
        data: data,
        metrics: metrics,
        warnings: $5151854d1465ccaf$var$buildWarnings(data, metrics),
        actions: $5151854d1465ccaf$var$buildActionPlan(data, metrics),
        instruments: $5151854d1465ccaf$var$buildInstrumentCards(data, metrics),
        profileAdvice: $5151854d1465ccaf$var$buildProfileAdvice(data, metrics),
        keyTakeaways: $5151854d1465ccaf$var$buildKeyTakeaways(data, metrics),
        score: $5151854d1465ccaf$var$buildScore(data, metrics)
    };
}
const $5151854d1465ccaf$var$SCORE_LEVELS = [
    {
        min: 95,
        name: 'Da manuale',
        icon: 'trophy'
    },
    {
        min: 85,
        name: 'Quasi da manuale',
        icon: 'medal'
    },
    {
        min: 75,
        name: 'Assetto solido',
        icon: 'shield-check'
    },
    {
        min: 60,
        name: 'Sulla buona strada',
        icon: 'signpost'
    },
    {
        min: 45,
        name: 'Zoppicante ma in piedi',
        icon: 'bandaids'
    },
    {
        min: 30,
        name: 'Cantiere aperto',
        icon: 'hammer'
    },
    {
        min: 15,
        name: 'Fondamenta scoperte',
        icon: 'barricade'
    },
    {
        min: 0,
        name: 'Allarme rosso',
        icon: 'siren'
    }
];
// Pesi della pagella (sommano 100); il malus vale per ogni incoerenza di rischio.
const $5151854d1465ccaf$var$SCORE_WEIGHTS = {
    savings: 20,
    emergency: 25,
    debts: 15,
    goals: 15,
    efficiency: 15,
    costs: 10
};
const $5151854d1465ccaf$var$SCORE_MALUS = 10;
function $5151854d1465ccaf$var$buildScore(data, metrics) {
    const components = [];
    const savingsPoints = Math.round(Math.min(Math.max(metrics.savingsRate, 0) / 20, 1) * $5151854d1465ccaf$var$SCORE_WEIGHTS.savings);
    components.push({
        label: 'Margine mensile',
        points: savingsPoints,
        max: $5151854d1465ccaf$var$SCORE_WEIGHTS.savings,
        note: metrics.cashFlow > 0 ? `risparmi il ${(0, $bdDJG.percent)(metrics.savingsRate)} del reddito (sopra il 20% \xe8 considerato sano)` : "spendi quanto o pi\xf9 di quanto entra"
    });
    const emergencyPoints = metrics.emergencyTarget > 0 ? Math.round(Math.min(metrics.emergencyCurrent / metrics.emergencyTarget, 1) * $5151854d1465ccaf$var$SCORE_WEIGHTS.emergency) : $5151854d1465ccaf$var$SCORE_WEIGHTS.emergency;
    components.push({
        label: 'Fondo emergenza',
        points: emergencyPoints,
        max: $5151854d1465ccaf$var$SCORE_WEIGHTS.emergency,
        note: metrics.emergencyGap > 0 ? `mancano ${(0, $bdDJG.euro)(metrics.emergencyGap)}` : metrics.emergencyExcess > 0 ? `completo, ${(0, $bdDJG.euro)(metrics.emergencyExcess)} oltre il target` : 'completo'
    });
    const hasHighRateDebt = metrics.debts.some((debt)=>debt.rate > 10);
    const hasMidRateDebt = metrics.debts.some((debt)=>debt.rate > 5 && debt.rate <= 10);
    const debtPoints = hasHighRateDebt ? 0 : hasMidRateDebt ? 8 : $5151854d1465ccaf$var$SCORE_WEIGHTS.debts;
    components.push({
        label: 'Debiti',
        points: debtPoints,
        max: $5151854d1465ccaf$var$SCORE_WEIGHTS.debts,
        note: hasHighRateDebt ? "c'\xe8 un debito sopra il 10%" : hasMidRateDebt ? 'tassi medi da tenere d\'occhio' : metrics.debts.length ? 'solo debiti a basso costo' : 'nessun debito'
    });
    const totalGoalAmount = metrics.goalCoverage.reduce((sum, goal)=>sum + goal.amount, 0);
    const coveredGoalAmount = metrics.goalCoverage.reduce((sum, goal)=>sum + goal.coveredAmount, 0);
    const goalPoints = totalGoalAmount > 0 ? Math.round(coveredGoalAmount / totalGoalAmount * $5151854d1465ccaf$var$SCORE_WEIGHTS.goals) : $5151854d1465ccaf$var$SCORE_WEIGHTS.goals;
    components.push({
        label: 'Spese previste',
        points: goalPoints,
        max: $5151854d1465ccaf$var$SCORE_WEIGHTS.goals,
        note: totalGoalAmount > 0 ? `coperte al ${Math.round(coveredGoalAmount / totalGoalAmount * 100)}%` : 'nessuna spesa in vista'
    });
    const idleMoney = metrics.idleCash;
    const totalLiquid = $5151854d1465ccaf$export$bd64c3cff6c9a648(data) + metrics.totalDepositBalance + metrics.investments.cash;
    const idleRatio = totalLiquid > 0 ? Math.min(idleMoney / totalLiquid, 1) : 0;
    let efficiencyPoints = Math.round((1 - idleRatio) * $5151854d1465ccaf$var$SCORE_WEIGHTS.efficiency);
    if (data.emergencyLocation === 'deposit_bound') efficiencyPoints = Math.max(efficiencyPoints - 5, 0);
    components.push({
        label: 'Soldi che rendono',
        points: efficiencyPoints,
        max: $5151854d1465ccaf$var$SCORE_WEIGHTS.efficiency,
        note: idleMoney > 0 ? `${(0, $bdDJG.euro)(idleMoney)} fermi a tasso zero` : 'nessun soldo fermo a tasso zero'
    });
    const annualCosts = (0, $bdDJG.clampNumber)(data.accountFee) + (0, $bdDJG.clampNumber)(data.creditCardFee) + (0, $bdDJG.clampNumber)(data.brokerFee);
    const costPoints = Math.round(Math.max(0, 1 - Math.min(annualCosts / 300, 1)) * $5151854d1465ccaf$var$SCORE_WEIGHTS.costs);
    components.push({
        label: 'Costi bancari',
        points: costPoints,
        max: $5151854d1465ccaf$var$SCORE_WEIGHTS.costs,
        note: annualCosts > 0 ? `${(0, $bdDJG.euro)(annualCosts)} all\'anno` : 'zero costi'
    });
    // Malus trasparenti: incoerenze di rischio che i punti base non vedono
    const riskyValue = metrics.investments.stocks + metrics.investments.crypto;
    const diversifiedValue = metrics.investments.etf + metrics.investments.funds + metrics.investments.bonds + metrics.investments.moneyMarket + metrics.investments.postalBonds + metrics.investments.lifeInsurance;
    if (riskyValue > 10000 && riskyValue > diversifiedValue) components.push({
        label: 'Portafoglio concentrato',
        points: -$5151854d1465ccaf$var$SCORE_MALUS,
        max: 0,
        note: 'molto peso su azioni singole o crypto',
        malus: true
    });
    if (metrics.riskTolerance === 'low' && metrics.riskyInvestmentsValue > 0) components.push({
        label: 'Comportamento a rischio',
        points: -$5151854d1465ccaf$var$SCORE_MALUS,
        max: 0,
        note: 'con questa reazione ai ribassi, il capitale volatile pesa',
        malus: true
    });
    // Patrimonio rilevante chiuso in polizza mentre fondo o spese previste sono
    // scoperti: incoerenza osservabile, non un giudizio sui costi (che non vediamo)
    if (metrics.lifeInsurance.value >= 5000 && (metrics.emergencyGap > 0 || metrics.uncoveredGoalsWithinTenYears.length > 0)) components.push({
        label: 'Polizza prima delle basi',
        points: -$5151854d1465ccaf$var$SCORE_MALUS,
        max: 0,
        note: metrics.emergencyGap > 0 ? 'risparmio bloccato in polizza col fondo emergenza scoperto' : 'risparmio bloccato in polizza con spese previste scoperte',
        malus: true
    });
    let total = Math.max(components.reduce((sum, component)=>sum + component.points, 0), 0);
    // Prerequisiti falliti: il voto non può dire "va tutto bene"
    if (metrics.cashFlow < 0) total = Math.min(total, 35);
    if (hasHighRateDebt && metrics.emergencyGap > 0) total = Math.min(total, 29);
    const verdict = total >= 85 ? 'Situazione solida: si lavora di fino.' : total >= 70 ? 'Buona base: qualche ottimizzazione e ci sei.' : total >= 50 ? "Ci sono cose da sistemare, ma la strada \xe8 chiara." : 'Serve rimettere ordine: si parte dalle basi.';
    const band = total >= 85 ? 'good' : total >= 70 ? 'fair' : total >= 50 ? 'warn' : 'bad';
    const level = $5151854d1465ccaf$var$SCORE_LEVELS.find((item)=>total >= item.min) || $5151854d1465ccaf$var$SCORE_LEVELS[$5151854d1465ccaf$var$SCORE_LEVELS.length - 1];
    return {
        total: total,
        verdict: verdict,
        band: band,
        level: level,
        components: components
    };
}
function $5151854d1465ccaf$var$buildKeyTakeaways(data, metrics) {
    const takeaways = [];
    const highRateDebt = metrics.debts.find((debt)=>debt.rate > 10);
    const currentFocus = highRateDebt ? 'Nel tuo caso il piano parte ancora prima dei pilastri: estinguere il debito costoso.' : metrics.emergencyGap > 0 ? `Tu sei al pilastro 2: ti mancano ${(0, $bdDJG.euro)(metrics.emergencyGap)} per completare il fondo emergenza.` : metrics.uncoveredGoalsWithinTenYears.length > 0 ? 'Tu sei al pilastro 3: le tue spese previste non sono ancora tutte coperte da strumenti sicuri.' : metrics.longTermInvestingAllowed ? 'Tu hai le basi in ordine: puoi ragionare sul pilastro 4, il lungo termine.' : "Tu stai ancora consolidando le basi: liquidit\xe0 e sicurezza vengono prima del rischio.";
    takeaways.push({
        icon: 'stack',
        title: 'I soldi si organizzano in 4 pilastri, in ordine',
        body: `Prima la liquidit\xe0 per il mese (1), poi il fondo emergenza (2), poi le spese previste nei prossimi 10 anni (3), e solo alla fine gli investimenti di lungo termine (4). Saltare l'ordine significa prendere rischi che non controlli. ${currentFocus}`
    });
    const emergencyRule = $5151854d1465ccaf$export$f4dfd234fa9a4a13(data);
    takeaways.push({
        icon: 'shield-check',
        title: 'Il tuo numero di sicurezza',
        body: `Il fondo emergenza si calcola sulle tue spese mensili: ${(0, $bdDJG.euro)(metrics.expenses)} x ${String(emergencyRule.months).replace('.', ',')} mesi = ${(0, $bdDJG.euro)(metrics.emergencyTarget)}. I mesi non sono un dogma: ${emergencyRule.reason}. Tienilo dove \xe8 subito disponibile, non oscilla e rende qualcosa: conto corrente remunerato con la somma ben distinta, o conto deposito libero o svincolabile. Su un conto che non rende, l'inflazione se lo mangia piano piano.`
    });
    const nearestGoal = metrics.goalCoverage.length > 0 ? metrics.goalCoverage[0] : null;
    takeaways.push({
        icon: 'clock-countdown',
        title: 'A ogni orizzonte il suo strumento',
        body: `Mai mettere in strumenti che oscillano i soldi che ti servono entro 10 anni. Entro 1 anno: conto remunerato, BOT od ETF monetario. Da 1 a 3 anni: conto deposito, BOT od ETF monetario. Da 3 a 10: BTP con scadenza coerente. Oltre 10: si pu\xf2 parlare di azionario diversificato.${nearestGoal ? ` Per te il primo banco di prova \xe8 "${nearestGoal.label}" ${$5151854d1465ccaf$export$aca044a98be75fce(nearestGoal.years)}: ${$5151854d1465ccaf$export$94f35dad18a9751d(nearestGoal.recommendedInstrument)}.` : ''}`
    });
    const annualBankingCosts = (0, $bdDJG.clampNumber)(data.accountFee) + (0, $bdDJG.clampNumber)(data.creditCardFee) + (0, $bdDJG.clampNumber)(data.brokerFee);
    takeaways.push({
        icon: 'coins',
        title: 'I costi sono un rendimento negativo garantito',
        body: annualBankingCosts > 0 ? `Oggi paghi circa ${(0, $bdDJG.euro)(annualBankingCosts)} all'anno tra conto, carte e broker. Per compensarli servirebbero ${(0, $bdDJG.euro)(annualBankingCosts * 20)} investiti al 5%. Tagliare i costi \xe8 il primo "investimento" da fare: \xe8 certo, immediato e senza rischio. Lo stesso principio vale per i fondi comuni cari e per gli ETF: cerca sempre TER sotto lo 0,25%.` : 'Canoni, commissioni e costi di gestione si pagano sempre, che i mercati salgano o scendano. Ogni 100 euro di costi annui equivalgono a 2.000 euro investiti al 5%. Per questo un ETF con TER sotto lo 0,25% batte quasi sempre un fondo comune con costi sopra il 2%.'
    });
    takeaways.push({
        icon: 'hand-coins',
        title: highRateDebt ? 'Il tuo debito costoso viene prima di tutto' : "Estinguere un debito \xe8 un investimento",
        body: highRateDebt ? `Il tuo debito pi\xf9 costoso (${highRateDebt.label.toLowerCase()} al ${(0, $bdDJG.percentPrecise)(highRateDebt.rate)}) ti costa pi\xf9 di quanto qualsiasi investimento prudente possa rendere. Ogni euro usato per estinguerlo "rende" il ${(0, $bdDJG.percentPrecise)(highRateDebt.rate)}, garantito. Prima si chiude, prima il resto del piano si sblocca.` : 'Ogni euro usato per estinguere un debito rende quanto il tasso del debito, garantito e senza rischio. Sopra il 10% l\'estinzione batte qualsiasi alternativa; sotto il 4-5% (un buon mutuo) spesso conviene invece usare il margine per costruire il resto del piano.'
    });
    const behaviourBody = data.reactionDrop === 'sell' ? "Hai indicato che con un -20% venderesti tutto: \xe8 la reazione pi\xf9 naturale e anche la pi\xf9 costosa, perch\xe9 trasforma un ribasso temporaneo in una perdita definitiva. Per te contano strumenti stabili: la serenit\xe0 vale pi\xf9 del rendimento extra." : data.checkFrequency === 'daily' ? "Controlli i prezzi ogni giorno: \xe8 il modo pi\xf9 efficace per farsi prendere dall'ansia e vendere nel momento sbagliato. Un piano ben costruito si controlla poche volte all'anno." : "L'errore pi\xf9 costoso non \xe8 scegliere lo strumento sbagliato, ma vendere in preda alla paura durante un ribasso. Un buon piano \xe8 quello che riesci a mantenere anche quando i mercati scendono: se regge solo finch\xe9 tutto sale, non \xe8 un piano.";
    takeaways.push({
        icon: 'brain',
        title: "Il comportamento conta pi\xf9 della strategia",
        body: behaviourBody
    });
    return takeaways;
}
function $5151854d1465ccaf$var$buildProfileAdvice(data, metrics) {
    const advice = [];
    const age = (0, $bdDJG.clampNumber)(data.age);
    if (data.reactionDrop || data.checkFrequency) {
        const reactionMirror = {
            sell: 'hai detto che a un calo del 20% venderesti',
            hold: 'hai detto che a un calo del 20% terresti duro, anche se con ansia',
            buy: "hai detto che a un calo del 20% compreresti di pi\xf9",
            ignore: 'hai detto che a un calo del 20% non guarderesti nemmeno i prezzi'
        }[data.reactionDrop];
        const freqMirror = {
            never: 'non controlli mai i prezzi',
            yearly: 'controlli una volta all\'anno',
            monthly: 'controlli una volta al mese',
            weekly: 'controlli una volta a settimana',
            daily: 'controlli i prezzi ogni giorno'
        }[data.checkFrequency];
        const profileName = {
            low: 'Prudente',
            medium: 'Equilibrato',
            high: 'Dinamico'
        }[metrics.riskTolerance];
        const profileMeaning = {
            low: "Chi si riconosce qui di solito sta meglio con strumenti che oscillano poco: la serenit\xe0 vale pi\xf9 del rendimento in pi\xf9, e un piano che non riesci a mantenere durante un crollo non \xe8 un piano.",
            medium: "Chi si riconosce qui accetta oscillazioni contenute, purch\xe9 abbia davanti abbastanza anni per assorbirle.",
            high: "Chi si riconosce qui regge i ribassi senza vendere, ed \xe8 la condizione che serve davvero per restare investito a lungo termine."
        }[metrics.riskTolerance];
        advice.push({
            title: `Il tuo atteggiamento verso il rischio: ${profileName}`,
            body: `Hai detto che ${[
                reactionMirror ? reactionMirror.replace('hai detto che ', '') : null,
                freqMirror
            ].filter(Boolean).join(', e che ')}. Messe insieme, queste due risposte descrivono un atteggiamento che di solito viene chiamato "${profileName.toLowerCase()}". ${profileMeaning} Nella sezione sull'allocazione trovi cosa comporta di solito ciascun profilo: la riga in cui ti riconosci la scegli tu.`,
            highlight: metrics.riskTolerance === 'low'
        });
    }
    if (age > 0 && age < 26 && (data.familyStatus === 'parents' || data.housingStatus === 'parents_house')) advice.push({
        title: 'Giovane che vive con i genitori',
        body: 'Sei nella posizione migliore per costruire risparmio: spese basse, tempo dalla tua parte, nessuna responsabilit\xe0 gravosa. Abituati a risparmiare ora, anche solo 50-100 euro al mese. Considera un "fondo indipendenza" di 10.000-20.000 euro per quando dovrai affittare. Se hai orizzonte lungo, anche piccoli importi in ETF possono contare molto grazie all\'interesse composto.',
        highlight: true
    });
    if (age > 55 && age <= 90) advice.push({
        title: 'Vicino alla pensione',
        body: "Con la pensione a meno di 15 anni, la priorit\xe0 \xe8 proteggere il capitale piuttosto che cercare rendimenti alti: in questa fase, di solito, il peso delle azioni si riduce a favore di strumenti pi\xf9 stabili. Valuta attentamente il tuo fondo pensione: se i costi superano l'1% e la tua aliquota IRPEF \xe8 alta, il beneficio fiscale potrebbe non compensare i costi di gestione.",
        highlight: false
    });
    if (metrics.cashFlow > 2000) advice.push({
        title: 'Alto potenziale di risparmio',
        body: `Risparmi ${(0, $bdDJG.euro)(metrics.cashFlow)}/mese, ovvero ${(0, $bdDJG.euro)(metrics.cashFlow * 12)}/anno. Puoi completare il fondo emergenza, coprire gli obiettivi e iniziare a investire a lungo termine molto pi\xf9 velocemente della media. Considera anche l'ottimizzazione fiscale: con aliquote IRPEF alte, il versamento al fondo pensione (fino a 5.164 euro/anno) offre un vantaggio fiscale significativo.`,
        highlight: true
    });
    if (metrics.cashFlow < 0) advice.push({
        title: 'Prima di tutto: ripristina il cash flow',
        body: "Le spese superano le entrate. Nessuna strategia finanziaria pu\xf2 funzionare in questa condizione. Controlla gli ultimi 3 estratti conto, identifica le spese ricorrenti eliminabili (abbonamenti inutilizzati, costi fissi troppo alti) e cerca di aumentare le entrate.",
        highlight: true
    });
    if (metrics.cashFlow === 0) advice.push({
        title: 'Sei in equilibrio fragile',
        body: 'Basta una spesa imprevista per andare in negativo. Cerca di trovare almeno 50-100 euro al mese di margine: con 100 euro al mese, in dieci mesi hai il primo mattone da 1.000 euro, la soglia che copre la spesa imprevista tipica.',
        highlight: true
    });
    if (data.pensionFund === 'pip') advice.push({
        title: 'Hai un PIP: guarda l\'indicatore dei costi',
        body: "I Piani Individuali Pensionistici hanno in media i costi pi\xf9 alti della previdenza complementare: l'ISC (indicatore sintetico dei costi) dei PIP supera spesso il 2% annuo, contro meno dell'1% dei fondi negoziali di categoria. Su decenni la differenza pesa pi\xf9 del vantaggio fiscale. Cerca l'ISC del tuo PIP nella scheda costi COVIP e, se lavori come dipendente, verifica se hai accesso a un fondo negoziale: il trasferimento \xe8 un tuo diritto e il montante si sposta senza tassazione.",
        highlight: true
    });
    if (data.pensionFund === 'open' || data.pensionFund === 'closed' || data.pensionFund === 'tfr' || data.pensionFund === 'pip') {
        const taxRate = metrics.marginalTaxRate;
        if (taxRate !== null && taxRate >= 35) advice.push({
            title: 'Fondo pensione: forte vantaggio fiscale',
            body: `Con un reddito complessivo annuo lordo di ${(0, $bdDJG.euro)((0, $bdDJG.clampNumber)(data.ral))} e un\'aliquota marginale del ${taxRate}%, il fondo pensione offre un vantaggio significativo. Versando 5.164 euro all\'anno (il massimo deducibile), recuperi circa ${(0, $bdDJG.euro)(Math.round(5164 * taxRate / 100))} in dichiarazione dei redditi. Controlla che i costi di gestione non superino l\'1%: se sono troppo alti, il beneficio fiscale viene eroso.`,
            highlight: true
        });
        else if (taxRate !== null && taxRate >= 23) advice.push({
            title: 'Hai un fondo pensione',
            body: `Con aliquota marginale del ${taxRate}%, il beneficio fiscale del fondo pensione \xe8 moderato: versando 5.164 euro recuperi circa ${(0, $bdDJG.euro)(Math.round(5164 * taxRate / 100))}/anno. Il vantaggio esiste ma \xe8 pi\xf9 contenuto. Controlla attentamente i costi di gestione: sopra l'1% annuo il vantaggio fiscale si assottiglia in fretta.`,
            highlight: false
        });
        else advice.push({
            title: 'Hai un fondo pensione',
            body: "Controlla due cose: i costi di gestione del fondo (se superano l'1% valuta alternative) e la tua aliquota IRPEF (se \xe8 alta, il beneficio fiscale del versamento \xe8 pi\xf9 significativo). Non \xe8 detto che il fondo pensione sia la scelta migliore in assoluto: dipende dai tuoi costi e dalla tua situazione fiscale.",
            highlight: false
        });
    }
    if (data.pensionFund === 'none') {
        const taxRate = metrics.marginalTaxRate;
        if (taxRate !== null && taxRate >= 35) advice.push({
            title: 'Considera un fondo pensione',
            body: `Con un reddito complessivo annuo lordo di ${(0, $bdDJG.euro)((0, $bdDJG.clampNumber)(data.ral))} e aliquota marginale del ${taxRate}%, un fondo pensione potrebbe farti recuperare fino a ${(0, $bdDJG.euro)(Math.round(5164 * taxRate / 100))}/anno. Verifica se la tua azienda offre un fondo negoziale con contributo del datore di lavoro: in quel caso il vantaggio \xe8 ancora maggiore. Non \xe8 prioritario rispetto al fondo emergenza, ma va considerato.`,
            highlight: false
        });
    }
    // Tax advice
    if (metrics.totalDepositBalance > 0) advice.push({
        title: 'Imposta di bollo sul deposito',
        body: `Il tuo conto deposito ha un saldo di ${(0, $bdDJG.euro)(metrics.totalDepositBalance)}. Sui conti deposito il bollo \xe8 proporzionale: 0,20% all'anno, circa ${(0, $bdDJG.euro)(Math.round(metrics.totalDepositBalance * $5151854d1465ccaf$var$STAMP_DUTY_PRODUCTS_RATE))} nel tuo caso, spesso detratto direttamente dagli interessi. Sui conti correnti invece il bollo \xe8 fisso: 34,20 euro all'anno solo se la giacenza media supera i 5.000 euro.`,
        highlight: false
    });
    const shortGoals = metrics.goalCoverage.filter((goal)=>goal.years <= 1 && goal.gap > 0);
    if (shortGoals.length > 0 && metrics.totalDepositBalance > 0) advice.push({
        title: 'BOT per obiettivi a breve termine',
        body: `Hai obiettivi entro 12 mesi ancora scoperti per ${(0, $bdDJG.euro)(shortGoals.reduce((sum, goal)=>sum + goal.gap, 0))}. I BOT offrono tassazione agevolata al 12,5% (contro il 26% del conto deposito). Se l'obiettivo ha una data certa, un BOT che scade in quel momento ti permette di risparmiare sulla tassazione degli interessi.`,
        highlight: true
    });
    if (metrics.investments.etf > 0 || metrics.investments.stocks > 0) advice.push({
        title: 'Imposta di bollo sul conto titoli',
        body: `Se hai ETF o azioni, il conto titoli \xe8 soggetto all'imposta di bollo dello 0,20% annuo sul controvalore. Con ${(0, $bdDJG.euro)(metrics.investments.etf + metrics.investments.stocks)} di investimenti, il bollo \xe8 di circa ${(0, $bdDJG.euro)(Math.round((metrics.investments.etf + metrics.investments.stocks) * $5151854d1465ccaf$var$STAMP_DUTY_PRODUCTS_RATE))}/anno. Alcuni broker lo includono nel canone.`,
        highlight: false
    });
    // Buoni postali: la fiscalità è buona sempre, il rendimento dipende dalla serie
    if (metrics.investments.postalBonds > 0) advice.push({
        title: 'Buoni postali: controlla la serie, non solo il saldo',
        body: `Hai ${(0, $bdDJG.euro)(metrics.investments.postalBonds)} in buoni fruttiferi. Due cose giocano a tuo favore: la tassazione al 12,5% come i titoli di Stato e la garanzia dello Stato via CDP. La variabile che decide tutto \xe8 la serie: il rendimento cresce a gradini con gli anni di possesso, e le serie recenti spesso rendono meno di un conto deposito o di un BTP di pari durata. Cerca il rendimento effettivo a scadenza della tua serie sul foglio informativo: se \xe8 basso e i buoni sono recenti, il rimborso \xe8 gratuito e restituisce almeno il capitale versato.`,
        highlight: true
    });
    // Polizza di risparmio: la domanda giusta è sui costi, con qualunque mercato
    if (metrics.lifeInsurance.value > 0) advice.push({
        title: metrics.lifeInsurance.kind === 'unknown' ? 'Polizza di risparmio: scopri cosa hai firmato' : 'Polizza di risparmio: chiedi il conto dei costi',
        body: metrics.lifeInsurance.kind === 'unknown' ? `Hai ${(0, $bdDJG.euro)(metrics.lifeInsurance.value)} in una polizza di cui non conosci la natura, ed \xe8 la cosa da sistemare per prima: chiedi alla compagnia (o alla banca che te l'ha proposta) il rendiconto annuale e il set informativo KID. Da l\xec capisci se il capitale \xe8 garantito o investe in fondi, quanto paghi ogni anno e cosa costa uscire. Con quei numeri, il check-up pu\xf2 dare a quei soldi un compito vero.` : `Hai ${(0, $bdDJG.euro)(metrics.lifeInsurance.value)} in una polizza di risparmio. Il rendimento lo fanno i mercati, i costi li decide il contratto: caricamenti sui versamenti, gestione annua e penali di riscatto stanno nel rendiconto e nel KID. Chiedili e somma tutto: sopra il 2% all'anno la polizza parte con un handicap che quasi nessuna gestione recupera. Non \xe8 un invito a riscattare: \xe8 un invito a decidere coi numeri davanti, contando anche quello che le polizze danno (esenzione da successione, capitale ai beneficiari fuori dall'asse ereditario).`,
        highlight: true
    });
    // Insurance advice: il censimento TCM rende i consigli condizionali, non a pioggia
    const isEmployee = data.workStatus === 'employee_permanent' || data.workStatus === 'employee_fixed';
    const hasTcm = data.hasTcm === 'yes';
    if (!hasTcm && isEmployee && age > 0 && age < 55 && (0, $bdDJG.clampNumber)(data.dependents) > 0) advice.push({
        title: 'Assicurazione TCM: proteggi chi dipende da te',
        body: "Con persone a carico e un lavoro dipendente, esiste una categoria di polizze pensata esattamente per questo rischio: la Temporanea Caso Morte (TCM), che copre i tuoi familiari se accade qualcosa a te. I costi tipici sono contenuti (15-30 euro/mese per un capitale di 200.000-300.000 euro) e la copertura \xe8 focalizzata sul rischio reale. Attenzione a non confonderla con le polizze vita proposte in banca, che spesso costano di pi\xf9 per coperture meno flessibili.",
        highlight: false
    });
    if (hasTcm && (0, $bdDJG.clampNumber)(data.dependents) > 0) {
        const mortgageRemaining = (0, $bdDJG.clampNumber)(data.debtMortgageAmount);
        advice.push({
            title: "Hai gi\xe0 una TCM: verifica il massimale",
            body: `La copertura c'\xe8, resta da controllare che basti. Il riferimento pratico \xe8 un capitale assicurato di almeno 4-5 volte il reddito annuo di chi lo porta a casa${mortgageRemaining > 0 ? `, e comunque non meno del debito residuo del mutuo (${(0, $bdDJG.euro)(mortgageRemaining)})` : ''}. Controlla anche la durata: la polizza dovrebbe coprire finch\xe9 qualcuno dipende dal tuo reddito, non un anno di meno. Se il massimale \xe8 basso, adeguarlo di solito costa pochi euro al mese.`,
            highlight: false
        });
    }
    if (!hasTcm && isEmployee && data.housingStatus === 'owner_mortgage') {
        const mortgageRemaining = (0, $bdDJG.clampNumber)(data.debtMortgageAmount);
        if (mortgageRemaining > 0) advice.push({
            title: 'Copertura mutuo',
            body: `Hai un mutuo residuo di ${(0, $bdDJG.euro)(mortgageRemaining)}. Verifica se la tua banca ha gi\xe0 incluso una copertura in caso di decesso o invalidita. Se non \xe8 inclusa, una TCM con capitale almeno pari al debito residuo protegge i tuoi familiari dal rischio di perdere la casa.`,
            highlight: false
        });
    }
    return advice;
}

});


//# sourceMappingURL=risultati.74afa87f.js.map
